import appConfig from "../../../config/app_config";
import { store } from "../../store.js"; // Uses the library to store or retrieve generic data

export const DE = {
  FORM_VALIDATE_1_TITLE:
    "Haben Sie alle erforderlichen Parameter korrekt eingegeben?",
  FORM_VALIDATE_1_BODY_1:
    "Klicken Sie für Polylinien auf 'Bereich definieren' und dann auf 'Alt' und klicken Sie auf das Polygon",
  FORM_VALIDATE_1_BODY_2:
    "Klicken Sie für Längen- und Breitengrad mit der rechten Maustaste auf den Mittelpunkt",
  FORM_VALIDATE_1_BODY_3: "Transportart fehlt",
  FORM_VALIDATE_1_BODY_4:
    "Polylinie hat die maximale Länge von 4096 Zeichen erreicht",
  FORM_VALIDATE_1_BODY_5: "Wählen Sie einen 'PartOf' Ort",
  HELPER_DRAW_POLYLINE: "Zeichnen Sie Ihre Standortpolylinie",
  HELPER_DRAW_POLYLINE_2:
    "Alt + Klicken, um Polylinienpunkte für Positionen festzulegen\n\nKlicken Sie dann mit der rechten Maustaste, um den Mittelpunkt festzulegen",
  CONTEXT_PLAN: "Planen",
  CONTEXT_TAGS: "Stichworte",
  CONTEXT_ADD: "Kind hinzufügen",
  CONTEXT_EDIT: "Bearbeiten",
  CONTEXT_REMOVE: "Kind löschen",
  EMAIL: "Email",
  NO_REPLY_EMAIL: "Keine Antwort-E-Mail-Adresse",
  LOG_OUT: "Ausloggen",
  DOUBLEUSERGROUP_ERROR:
    "Leider können Sie einem Benutzer nur eine Partnergruppe zuweisen.",
  DUPLICATEDPARTNERNAME_ERROR:
    "Der Partnername ist leider bereits in unserem System vorhanden. Bitte ändern Sie den Namen und fahren Sie fort.",
  YES_SEND_MSG: "Ja, Nachricht senden",
  SEND_MSG_TO_TS: "Nachricht an Zeitfenster senden: ",
  ON_THE: " auf der ",
  ENTER_TITLE_MSG: "Geben Sie den Titel der Nachricht ein",
  ENTER_TEXT_MSG: "Geben Sie den Text der Nachricht ein",
  SEND_MSG_TO_TS_CHECK:
    "Sind Sie sicher, dass Sie eine Nachricht an alle Benutzer aus dem Zeitfenster senden möchten: ",

  // Capacity Info page
  CAPACITY_INFO: "Kapazitätsinfo",
  CAP_CAL_FOR: "Kapazitätskalender für",
  CAP_SEL_EVENT:
    "Bitte wählen Sie ein Ereignis aus, um die Kalenderdaten abzurufen",
  CAP_EVENT_CAP: "Event capacity: ",
  CAP_FREE_EVENT_CAP: "Freie ereignis kapazität: ",
  CAP_FREE_BATCH_CAP: "Freie Chargenkapazität: ",
  CAP_BOOKED_BATCH_CAP: "Gebuchte Chargenkapazität: ",
  CAP_CUR_OCCUPANCY: "aktuelle Belegung: ",
  CAP_TOTAL_EVENT_CAP: "Gesamte ereignis kapazität: ",
  CAP_BATCH_TIME: "Batch-Zeit: ",
  CAP_TOTAL_BATCH_CAP: "Gesamte chargenkapazität: ",

  CREATE_EVENT: "Neues ereignis",
  CATEGORIES_NONE: "Keine Kategorien verfügbar",

  //payments status error
  EXPIRED: "Abgelaufen",
  CANCELED: "Abgebrochen",
  FAILED: "Gescheitert",

  COMM_MGR_05:
    "Es wurden keine Benutzer gefunden, die den ausgewählten Kriterien entsprechen!",
  DEFINE_AREA: "Bereich definieren",

  PIN: "Geheimzahl",
  WELCOME_MESSAGE_TITLE: "Herzlich willkommen",
  WELCOME_MESSAGE:
    "Willkommen auf Ihrer persönlichen Seite. Hier finden Sie alles, was Sie zur Planung und Personalisierung Ihres Besuchs benötigen " +
    appConfig.dss.environmentName +
    ". Sie können Ihre Einstellungen einfach unter Einstellungen ändern. Wir wünschen Ihnen viel Spaß bei Ihrem Besuch in  " +
    appConfig.dss.environmentName +
    " ",

  EDIT: "Bearbeiten",
  EDIT_MESSAGE: "Nachricht bearbeiten",

  MESSAGE_TITLE_1: "Welche Art von Nachricht möchten Sie senden?",
  MESSAGE_TITLE_2:
    "Sie können für eine einzelne Nachricht auswählen oder eine Engagement-Kampagne starten",
  MESSAGE_TITLE_3:
    "Um eine Nachricht zu senden, muss ich wissen, an wen Sie sie senden möchten.",
  MESSAGE_TITLE_4:
    "Was möchten Sie senden und wann sollte es an sie geliefert werden?",
  MESSAGE_TITLE_5:
    "Welche Besuchergruppe möchten Sie mit Ihrer Engagement-Kampagne erreichen?",
  MESSAGE_CATEGORY: "Nachrichtenkategorie",
  SELECT_MESSAGE_CATEGORY: "Wählen Sie eine Nachrichtenkategorie",

  PREVIEW: "Vorschau",

  START: "Chargendetails zufließen ",
  END: " Details zur Abflusscharge",
  "DATE/TIMEINFO": "Allgemeine Chargendetails mit allen anderen Feldern",
  PRICECATEGORIES: "Chargenpreisdetails",
  PRICECATEGORY_MIN_QUANTITY: "Minimale Menge",
  PRICECATEGORY_MAX_QUANTITY: "Höchstbetrag",
  PERIOD_INFO: "Details zur Ereignisstapeldauer",

  SELECT: "Wählen",
  CONTRIBUTORS: "Mitwirkende",
  PRODUCTS: "Produkte",
  CHOOSE_YOUR_PRODUCTS: "Wählen Sie Ihre Produkte",
  SETTINGS_SAVE_OK: "Einstellungen korrekt gespeichert",
  SETTINGS_SAVE_KO: "Fehler beim Speichern der Einstellungen",
  MY_VISIT: "Mein Besuch",
  EVENTS: "Veranstaltungen",
  SETTINGS: "die Einstellungen",
  INTERESTED_IN: "Ich interessiere mich für Veranstaltungen für",
  SELECT_LOCATION: "Wähle einen Standort",
  SELECT_EVENT: "Wählen Sie ein Ereignis aus",
  SELECT_TIME_PERIOD: "Wählen Sie einen Zeitraum",
  SELECT_FROM: "Von",
  SELECT_UNTIL: "Bis",
  SELECT_WINNER: "Gewinner auswählen",
  BACK: "Zurück",
  COMMUNICATION_CENTER: "Kommunikationszentrum",
  SAVED_COMMUNICATION: "Gespeicherte Kommunikation",
  NEW_COMMUNICATION: "Neue Kommunikation",
  COMMUNICATION: "Kommunikation",
  COMMUNICATIONS: "Kommunikation",
  TYPE: "Art",
  DATE: "Datum",
  TIME: "Zeit",
  CHOOSE_EVENT_OPTION: "Wählen Sie eine Ereignisoption",
  CHOOSE_BATCHGROUP_OPTION: "Wählen Sie eine Stapelgruppenoption",
  ENGAGEMENT_CAMPAIGN: "Starten Sie eine Engagement-Kampagne",
  ENGAGEMENT_CAMPAIGN_SUB:
    "Wird für die Werbung für die Veranstaltung und das Catering verwendet.",
  CATERING_PROMOTION: "Catering-Förderung",
  SECOND_PROMOTION: "Zweite Beförderung",
  PLANBOARD: "Planboard",
  MY_PLANBOARD: "Mein Planboard",
  SHOW_PLANBOARD: "Planboard anzeigen",
  WHOM: "Wem",
  SEND_MESSAGE_TO: "Nachricht senden an",
  WHAT: "Was",
  TITLE_MESSAGE: "Titelnachricht",
  LINK_TEXT: "Ausgehender Link",
  TEXT_MESSAGE: "Textnachricht",
  PROMOCODE: "Aktionscode",
  ADD_FAVORITE: "zu Favoriten hinzufügen",
  FAVORITE: "Favorit",
  WHEN: "Wann",
  NEW_MESSAGE: "Neue Nachricht",
  SINGLE_MESSAGE: "Senden Sie eine einzelne Nachricht",
  SINGLE_MESSAGE_SUB:
    "Wird für Updates oder zusätzliche Informationen für Ihre Besucher verwendet.",
  THE_LOTTERY: "Die Lotterie",
  START_LOTTERY: "Starten Sie die Lotterie",
  FIRST_PROMOTION: "Erste Beförderung",
  MESSAGE: "Botschaft",
  MESSAGES: "Mitteilungen",
  ERROR_HEADER: "Sieht so aus, als wäre etwas schief gelaufen.",
  ERROR_NO_CONNECTION:
    "Ein Problem ist aufgetreten. Bitte wenden Sie sich an das Kundendienstzentrum von The Driving Force",
  USER_PICTURE_UPLOAD:
    "Fügen Sie Ihr Foto hinzu, um Ihr Konto persönlich zu gestalten",
  USER_QR_CODE:
    "Dies ist Ihr persönlicher QR-Code. Sie können diesen Code scannen, um Briefmarken zu erhalten. Mit einem vollständigen Satz Briefmarken können Sie Rabatte erhalten. ",
  DISCOUNT: "Rabatt",
  ITEM_NUMBER: "Artikelnummer",

  EVENT_FLEX_ARRIVAL: "Prozentsatz flexibler Benutzer",
  EVENT_AVERAGE_WAITTIME: "Durchschnittliche Wartezeit",
  EVENT_MAX_WAITTIME: "Maximale Wartezeit",
  EVENT_AVERAGE_DEVIATION: "Durchschnittliche Abweichung",
  EVENT_MAX_DEVIATION: "Maximale Abweichung",
  DISTRIBUTION_IN_TIME: "DIT",
  DISTRIBUTION_IN_TIME_BIG: "Zeitliche Verteilung",
  DISTRIBUTION_IN_PLACE: "DIP",
  ERROR_LOGIN: "Fehler, falsche Daten",
  ERROR: "Error",
  ERROR_EMAIL_EXIST: "E-Mail vorhanden",

  TITLE_CHART_0: "Besucher",
  TITLE_CHART_1: "Wartezeit",
  TITLE_CHART_2: "Einträge",
  TITLE_CHART_3: "Vorfälle",
  TITLE_CHART_4: "Zuflussmuster",
  TITLE_CHART_5: "Abflussmuster",
  EMPTY_SLOT: "Leerer Schlitz",
  MOVE_SLOT_FORWARD: "Steckplatz verschieben",
  EVENT_TITLE: "Ereignis-Dashboard",
  INCIDENT_TITLE: "Vorfall",
  INCIDENT_TITLE_2: "",
  TOTAL_ARRIVALS: "Gesamtzahl der Ankünfte",

  // Homepage
  USER_LOGGED_OUT: "erfolgreich abgemeldet",
  ACTIVITIES_DESC:
    "Durchsuchen Sie die Themen und finden Sie Aktivitäten, die Ihnen gefallen",
  NO_CONTINUE_USING_WEBSITE: "Nein, ich möchte die Website nutzen",
  VIEW_ACTIVITIES: "Aussicht",
  SEARCH_ACTIVITY: "Suchen Sie nach einer Aktivität",
  HIGHLIGHTS: "Themen",
  HIGHLIGHTS_DESC:
    "Durchsuchen Sie die accountName Themenaktivitäten und finden Sie heraus, warum Sie auf jeden Fall accountName besuchen sollten",
  ACTIVITIES_FOR_HIGHLIGHT: "Aktivitäten für Themen ",
  ACTIVITIES_FOR_LOCATION: "Aktivitäten für den Standort ",
  CLOSE_ACTIVITIES: "Schließe dieses Fenster",
  GET_ACCOUNT_APP: "Holen Sie sich jetzt die accountName App!",
  ACCOUNT_APP_TEXT:
    "Holen Sie sich die accountName-App und lassen Sie sich von allem inspirieren, was Sie sehen und tun können. Die accountName-App bietet Ihnen viele Vorteile für Ihren Besuch in " +
    "accountName. Finden, buchen und greifen Sie ganz einfach mit wenigen Fingertipps auf Ihre Lieblingsaktivitäten zu.",
  ACCOUNT_APP_TEXT2:
    "Die accountName-App ist alles, was Sie benötigen, um Ihren accountName-Besuch optimal zu nutzen.",
  WHATS_ON: "Was läuft",
  WHATS_ON_DESC: "Was gibt es zu tun",
  FILTER_RESULTS: "Filter Ergebnisse",
  TODAY: "Heute",
  NEXT_7_DAYS: "Nächste 7 Tage",
  NEXT_30_DAYS: "Nächste 30 Tage",
  NEXT_3_MONTHS: "Nächste 3 Monate",
  SELECT_SPEC_DAYS: "Wählen Sie bestimmte Tage aus",
  WHAT_IS_WHERE: "Was ist wo?",
  WHAT_IS_WHERE_DESC: "Was ist wo",
  ACT_FOR_HIGHLIGHT: "Aktivitäten für dieses Thema!",
  ACTIVITIES: "Aktivitäten",
  GET_PERS_SUG:
    "Erhalten Sie personalisierte Vorschläge, indem Sie Kategorien mit den Schaltern auf der linken Seite auswählen. ",
  USER_WELCOME: "Willkommen zurück ",
  PASS_MAX_FUN: "Erstellen Sie einen Reisepass für maximalen Spaß",
  PERS_PASS: "Ihr persönlicher Reisepass",
  CREATE_PASS_DESC_1:
    "Erstellen Sie Ihren persönlichen Reisepass und holen Sie das Beste aus Ihrem Besuch heraus ",
  CREATE_PASS_DESC_2:
    "Der Reisepass bietet Ihnen Zugang zu exklusiven Aktivitäten und Ermäßigungen und ermöglicht es Ihnen, Ihren Besuch vollständig an Ihre Wünsche und Interessen anzupassen. Sie werden garantiert mehr Spaß haben. ",
  CREATE_PASS_NOW: "Erstellen Sie jetzt Ihren persönlichen Reisepass! ",
  CREATE_PASS: "Pass erstellen",
  PASS_DESC_1:
    "Planen Sie Ihren Besuch weiter oder erstellen Sie eine neue Reise nach ",
  PASS_DESC_2:
    "Gehen Sie zu Ihrem persönlichen Reisepass, um Ihre gespeicherten Favoriten, persönlichen Vorschläge und Interessen anzuzeigen.",
  GO_TO_PASS: "Gehen Sie zu Mein Konto",

  //QR-code scanner
  QR_CODE: "QR-code scanner",
  ENTER_AMOUNT: "Geben Sie den Betrag in Euro ein",
  SCAN_CODE: "Scannen Sie den QR-Code des Kunden",
  ERROR1: "Sie haben nichts eingegeben!",
  LAST_RESULT: "Letztes Ergebnis:",

  //User passport
  USER_PASSPORT: "Mein Konto",
  USER_PASSPORT_DESC:
    "Erstellen Sie Ihren persönlichen Reisepass, um Aktivitätsvorschläge zu personalisieren, besondere Belohnungen zu erhalten und Ihre Favoritenliste anzuzeigen.",
  USER_INTERRESTS: "Deine Interessen",
  USER_INTERRESTS_DESC:
    "Teilen Sie uns mit, an welchen Aktivitäten Sie interessiert sind, damit wir passende Aktivitäten anbieten können. ",
  YOUR_USER_REWARD_LVL: "Ihre aktuelle Belohnungsstufe",
  USER_REWARD_LVL: "Belohnungsstufe",
  USER_CURRENT_LEVEL: "Aktuelles Level",
  USER_REWARD_LVL_DESC:
    "Sammeln Sie Belohnungspunkte, indem Sie Aktivitäten ausführen. Holen Sie sich genug Punkte, um das nächste Level zu erreichen und spezielle Aktivitäten und Rabatte freizuschalten. ",
  USER_FAVORITES: "Deine Favoriten",
  USER_FAVORITES_DESC:
    "Aktivitäten, die Sie Ihrer Favoritenliste hinzugefügt haben. ",
  USER_REWARD_POINTS: "Punkte",
  USER_EARNED_POINTS: "Verdiente Punkte",
  USER_POINTS_TO_NEXT_LEVEL: "Zeigt auf das nächste Level",
  USER_INTERESTS: "Meine Interessen",
  DEL_FAV: "Favorit löschen",
  SURE_DELETE_ACTIVITY: "Möchten Sie die Aktivität wirklich löschen ",
  SURE_DELETE_FAV: " aus Ihrer Favoritenliste ? ",
  USER_DETAILS: "Persönliche Daten",
  USER_SELECTIONS: "Ihre Auswahl",
  USER_LOCATION_NOT_FOUND: "Adresse nicht gefunden",
  USER_LOCATION_NOT_FOUND_DESC: "Die Adresse wurde nicht gefunden",
  USER_LOCATION_NOT_FOUND_DESC2:
    "Beim Speichern Ihrer Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut",
  USER_DETAILS_NOT_SAVED: "Benutzerdaten werden nicht gespeichert",
  USER_DETAILS_SAVED: "Die Benutzerdaten werden gespeichert",
  GETTING_USER_INTERESTS: "Benutzerinteressen erhalten",
  FILTER_ACTIVITIES: "Aktivitäten filtern",

  //Incidents
  INCIDENT_DESCRIPTION_REPORTER: "Beschreibung des Reporters",
  INCIDENT_DESCRIPTION: "Fügen Sie eine Beschreibung hinzu",
  INCIDENT_HAPPEND: "Um welche Art von Vorfall handelt es sich",
  INCIDENT_FILL_IN: "Füllen Sie die Ereignisdaten aus",
  INCIDENT_TYPE: "Typ Vorfall",
  INCIDENT_LIFE_THREAT: "Lebensbedrohlich?",
  INCIDENT_SITUATION: "Lebensbedrohlich?",
  INCIDENT_LOCATION:
    "Wahr? (Klicken Sie mit der rechten Maustaste auf die Karte, auf der sich der Vorfall ereignet hat).",
  INCIDENT_EXACT_LOCATION: "Geben Sie den Speicherort an",
  INCIDENT_ROAD_ID: "Straßendaten",
  INCIDENT_ADRESS: "Adressdaten",
  INCIDENT_YES_NO: "Ja/Nein",
  INCIDENT_GPS: "GPS Koordinaten",
  INCIDENT_STREET: "Straßenname",
  INCIDENT_NUMMER: "Nummer",
  INCIDENT_PLACE: "Stadtname",
  INCIDENT_DESCRIPTION_PLACEHOLDER:
    "Beschreibung des genauen Standorts der Rettungsdienste.",
  INCIDENT_ADDITIONAL_LOCATION: "Zusätzlicher Standort",
  INCIDENT_PHOTO: "Kommentare und Foto hinzufügen.",
  INCIDENT_USER: "Name des Reporters",
  NO_INCIDENT_DATA: "Keine Vorfalldaten",
  GO_INCIDENT: "Sehen",
  NO_USERS: "Keine Benutzer gefunden",
  INCIDENT_CLOSE: "Vorfall schließen",
  INCIDENT_REMOVED: "Vorfall entfernt",
  INCIDENT_NOT_REMOVED: "Vorfall kann nicht entfernt werden",
  INCIDENT_DIALOG_CLOSE:
    "Sind Sie sicher, dass Sie diesen Vorfall schließen möchten??",
  INCIDENT_DIALOG_EDIT: "Wollen Sie die Änderungen speichern?",
  INCIDENT_SEND: "Senden",
  INCIDENT_EDIT: "Änderungen speichern",
  INCIDENT_PICTURE: "Ereignisbild",

  INC_1: "Verkehrsunfall",
  INC_2: "Trümmer",
  INC_3: "Verwundet",
  INC_4: "Überfüllt",
  INC_5: "Technischer Fehler",
  INC_6: "Verkehrsunfall",
  INC_7: "Feuer",
  INC_8: "Verdächtige Situation",
  YES: "Ja",
  NO: "Nein",

  //Event
  EVENT_ADD_REWARD_LEVEL: "Belohnungsstufe hinzufügen",
  EVENT_ASSIGN_REWARDS: "Weisen Sie Belohnungen zu",
  EVENT_ASSIGN_MORE_LOCATIONS: "Weisen Sie weitere Standorte zu",
  EVENT_REWARD_MANAGEMENT: "Belohnungsmanagement",
  EVENT_ASSIGN_EXTRA_LOCATIONS:
    "Um diesem Ereignis einen zusätzlichen Ort zuzuweisen, speichern Sie das Ereignis zuerst!",
  EVENT_ASSIGN_REWARD_EXPLANATION:
    "Um diesem Event mehrere Standorte zuzuweisen, speichern Sie bitte zuerst das Event!",
  EVENT_ASSIGN_MORE_LOCATIONS_EXPLANATION:
    "Um diesem Event eine Belohnung zuzuweisen, speichern Sie bitte zuerst das Event!",
  EVENT_REWARD_EXPLANATION:
    "Um diesem Event eine Belohnungsstufe hinzuzufügen, speichern Sie das Event bitte zuerst!",
  EVENT_DISCOUNT_CARDS_EXPLANATION:
    "Um eine Rabattkarte hinzuzufügen, speichern Sie bitte zuerst die Veranstaltung!",
  EVENT_DISCOUNT_CARDS: "Rabattkarten",
  EVENT_SUBACTIVITIES: "Unteraktivitäten",
  EVENT_ALTERNATIVES: "Alternativen",
  EVENT_TICKET_TYPES: "Ticketarten",
  EVENT_EXTRA: "Extra event",
  EVENT_STOP_NAME: "Name des Ereignisstopps",
  EVENT_END_LOCATION: "Endort",
  EVENT_START_LOCATION: "Startort",
  EVENT_LOCATION: "Veranstaltungsort",
  EVENT_ROUTE: "Ereignisroute",
  EVENT_RESET: "Zurücksetzen",
  EVENT_RANKING: "Event-Ranking",
  EVENT_PARTNER: "Veranstaltungspartner",
  EVENT_PRODUCT: "Veranstaltung/Produkte",
  EVENT_DATE_RANGE: "Datumsbereich",
  EVENT_AGE_RESTRICTIO: "Altersbeschränkung",
  EVENT_ACTIVE_COMPLETE_TIME: "vollständige Zeit aktivieren",
  EVENT_CHECK_IN_TIME: "Check-in-Zeit",
  EVENT_CHECK_OUT_TIME: "Check-aus-Zeit",
  EVENT_ACTIONS: "Akties",
  EVENT_EARLIEST_CHECKIN_TIME: "Früheste Check-in-Zeit",
  EVENT_LATEST_CHECKIN_TIME: "Späteste Check-in-Zeit",
  EVENT_DURATION_ARRIVAL_BATCHES: "Dauer Ankunft Chargen",
  EVENT_MAX_INFLOW: "Maximaler Zufluss",
  EVENT_EARLIEST_CHECKOUT_TIME: "Früheste Check-out-Zeit",
  EVENT_LATEST_CHECKOUT_TIME: "Späteste Check-out-Zeit",
  EVENT_DURATION_DEPARTURE_BATCHES: "Dauer Abflugchargen",
  EVENT_MAX_OUTFLOW: "Maximaler Abfluss",
  EVENT_STEPS: "Schritte",
  EVENT_MINIMAL_DURATION: "Minimale Dauer",
  EVENT_MAXIMUM_DURATION: "Maximale Dauer",
  EVENT_BOOKING_POLICY: "Buchungsrichtlinien",
  EVENT_FLEX_PERCENTAGE: "Flex-Prozentsatz",
  EVENT_PRICE_CATEGORY: "Preiskategorie",
  EVENT_ADD_PRICE_CATEGORY: "Preiskategorie hinzufügen",
  EVENT_THRESHOLD: "Schwelle",
  EVENT_PLEASE_ADD_PRICECATEGORY:
    "Bitte fügen Sie dieser Chargengruppe mindestens 1 Preiskategorie hinzu",
  EVENT_EXTERNAL_PLATFORM: "Externe Plattformen",
  EVENT_EXTERNAL_EVENT: "Externe Ereignis",
  EVENT_TOUR: "Touren",
  EVENT_AVERAGE_SPEED: "Durchschnittsgeschwindigkeit (km/h)",
  EVENT_DELIVERY_OR_TAKEAWAY:
    "Treffen Sie nach Möglichkeit die Wahl, ob das Produkt geliefert oder selbst abgeholt werden soll.",
  EVENT_INSERT_STARTTIME: "Geben Sie Ihre neue Startzeit ein",
  EVENT_INSERT_ENDTIME: "Geben Sie Ihre neue Endzeit ein",
  EVENT_CURRENT_START_AND_ENDTIME:
    "Ihre aktuelle Start- und Endzeit für das Ereignis: eventName ist",
  EVENT_CURRENT_START_AND_ENDDATE:
    "Ihr aktuelles Start- und Enddatum für event: eventName ist",
  EVENT_NO_TICKETS_SELECTED: "Es sind keine Tickets ausgewählt",
  EVENT_PLEASE_SELECT_TICKET: "Bitte wählen Sie Ihre Tickets",
  EVENT_NO_DATE_CHOSEN: "Kein Datum gewählt",
  EVENT_CHOOSE_DATE: "Wählen Sie ein Datum",
  EVENT_BOOK: "Event buchen",
  EVENT_INPUT_TIME_INCORRECT: "Die Startzeit ist später als die Endzeit",
  EVENT_TIME_INCORRECT: "Zeit falsch",
  EVENT_PREFERRED_ARRIVAL: "Bevorzugte Ankunftszeit",
  EVENT_PREFERRED_DEPARTURE: "Bevorzugte Abfahrtszeit",
  EVENT_STARTS_EVERY: "Startet jeden",
  NO_EVENT: "Keine Ereignisse gefunden",
  NO_EVENTS_NOW_FOR_PARTNER:
    "Für diesen Partner wurden keine Ereignisse gefunden",
  NO_EVENTS_NOW_FOR_ACCOUNT:
    "Für diesen Accounter wurden keine Ereignisse gefunden",
  EVENT: "Veranstaltung",
  EDIT_EVENT: "Ereignis bearbeiten",
  EVENT_EDIT: "Wählen Sie ein zu bearbeitendes Ereignis aus",
  EVENT_REGISTRATION: "Veranstaltungsanmeldung",
  EVENT_DURATION: "Dauer der Veranstaltung",
  EVENT_DESC_SHORT: "Beschreibung",
  EVENT_LOC_SHORT: "Standort",
  EVENT_CAP_SHORT: "Kapazität",
  EVENT_CAT_SHORT: "Kategorien",
  EVENT_PIC_SHORT: "Bild",
  EVENT_MESSAGE_PICTURE: "Nachrichtenbild",
  EVENT_MESSAGE_PRODUCT: "Produkt",
  EVENT_MESSAGE_PRODUCT_OPT: "Produkt (optional)",
  EVENT_MESSAGE_SELECT_PRODUCT: "Wähle ein Produkt",
  EVENT_BUDGET_SHORT: "Budget",
  EVENT_PARTOF_SHORT: "Teil von -Themen-",
  EVENT_TW_SHORT: "Zeitfenster",
  EVENT_PIC_NONE: "Kein Bild verfügbar",
  EVENT_VISIBILITY: "Sichtbar für",
  EVENT_NAME: "Name der Veranstaltung",
  EVENT_TYPE: "Art der Veranstaltung",
  EVENT_DESCRIPTION: "Beschreibung des Ereignisses",
  EVENT_STARTTIME: "Startzeit der Veranstaltung",
  EVENT_ENDTIME: "Endzeit der Veranstaltung",
  EVENT_INTERVAL: "Intervall",
  EVENT_MAXCAPACITY: "Maximale Kapazität pro Intervall",
  EVENT_INFLOWCAPACITY: "Kapazität pro Intervall",
  EVENT_PRICE: "Veranstaltungspreis",
  EVENT_MAX_WAIT_TIME: "Maximale Wartezeit in Minuten",
  EVENT_HISTORIC_ARRIVAL: "Historische Ankünfte",
  EVENT_LANGUAGE: "Sprachspezifikationen",
  EVENT_FILTERTYPE: "Filtern Sie Ereignisse nach Typ: ",
  EVENT_AGENDA_NEW: '"Neuer Tagesordnungspunkt',
  EVENT_DATES_SELECTION: "Auswahl der Daten",
  EVENT_DAYS_SELECTION: "Auswahl der Tage",
  EVENT_START_DATE: "Anfangsdatum",
  EVENT_END_DATE: "Endtermin",
  EVENT_START_TIME: "Startzeit",
  EVENT_END_TIME: "Endzeit",
  EVENT_MAX_INFLOW: "Maximaler Zufluss",
  EVENT_RATE_PRICE: "Preis bewerten",
  EVENT_REWARD_POINTS: "Belohnungspunkte",
  EVENT_NO_BATCHGROUPS: "Keine Tagesordnungspunkte verfügbar",
  EVENT_MESSAGE_TITLE: "Nachrichtentitel",
  EVENT_MESSAGE_TEXT: "Nachrichtentext",
  EVENT_MESSAGE_REW_LVL: "Nachricht an Belohnungsstufe senden",
  EVENT_USER_SELECTION: "Auswahl der Benutzer",
  EVENT_DATE: "Datum",
  EVENT_TIME: "Zeit",
  EVENT_COMM_TYPE: "Kommunikationsart",
  EVENT_MESSAGE_STATUS: "Nachrichtenstatus",
  EVENT_MESSAGE_SEND: "Senden",
  EVENT_MESSAGE_NOT_SEND: "Nicht senden",
  EVENT_ERROR_MSG_1:
    "Anscheinend haben Sie nicht alle erforderlichen Felder (korrekt) ausgefüllt.",
  EVENT_ERROR_MSG_2:
    "Bitte füllen Sie alle erforderlichen Felder aus, um fortzufahren.",
  EVENT_DEL_AGENDA_ITEM:
    "Möchten Sie diesen Tagesordnungspunkt wirklich löschen?",
  EVENT_DEL_MESSAGE: "Möchten Sie diese Nachricht wirklich löschen?",
  DELIVERY_PARTNER: "Lieferpartner",

  //// Event info buttons on the event wizard
  // Event detail screen
  EVENT_FORAGE_MESSAGE:
    "Dieses Produkt hat eine Bewertung von 18+. Können Sie bestätigen, dass Sie im richtigen Alter sind?",
  EVENT_NAME_INFO:
    "Der 'Name des Ereignisses' bestimmt den Namen für dieses Ereignis. Der Ereignisname wird für Kunden in der Kalenderübersicht angezeigt. entweder 'Fixed' oder 'Repetitive'. Wenn das Ereignis mehr als einmal am Tag auftritt, ist das Ereignis \"Wiederholend\".",
  EVENT_TYPE_INFO:
    "Der 'Ereignistyp' bestimmt den Typ dieses Ereignisses. Ein Ereignis ist entweder 'Fest' oder 'Wiederholend'. Wenn das Ereignis mehr als einmal am Tag auftritt, ist das Ereignis \"Wiederholend\".",
  EVENT_TW_INFO:
    "The 'Time-Window' of an event is either 'Fixed' or 'Repetitive'. If the event occures more than once a day, the event is 'Repetitive'.",
  EVENT_LOC_INFO:
    "Der 'Ort' ist der Ort, an dem die Veranstaltung stattfindet. Der Standort wird für Kunden in der Kalenderübersicht angezeigt.",
  EVENT_PARTOF_INFO:
    "Eine Veranstaltung kann Teil mehrerer Themen sein. Wenn das Ereignis nahtlos zu einem Thema passt, sollte dieses Ereignis zu diesem Thema hinzugefügt werden.",
  EVENT_CAP_INFO:
    "Die 'Kapazität' ist die maximale Kapazität der Veranstaltung.",
  EVENT_BUDGET_INFO:
    'Das "Budget" ist das Budget für eine Veranstaltung, wie oft es einem Kunden basierend auf dem "Preis" der Veranstaltung vorgeschlagen wird.',
  EVENT_LEAD_INFO:
    "Die 'Vorlaufzeit' ist die Vorlaufzeit in Minuten für das Ereignis (Standard ist 0).",
  EVENT_COOL_INFO:
    "Die 'Abklingzeit' ist die Abklingzeit in Minuten für das Ereignis (Standard ist 0).",
  DURATION_INFO:
    "Die 'Dauer' ist die Dauer in Minuten für das Ereignis (Standardeinstellung ist 60).",
  EVENT_DESC_INFO:
    "Die 'Beschreibung' der Veranstaltung ist eine kurze Einführung in die Veranstaltung. Die Beschreibung wird für Kunden im Bildschirm mit den Ereignisdetails angezeigt.",
  EVENT_PIC_INFO:
    "Das 'Bild' der Veranstaltung ist für Kunden in der Kalenderübersicht sichtbar und wenn ein Kunde eine Veranstaltung zur Information / Buchung öffnet.",
  EVENT_YT_LINK_INFO:
    "Der YouTube-Link wird bereitgestellt, damit der Benutzer den Link in der YouTube-Anwendung oder im Web öffnen kann.",
  // Event agenda screen
  EVENT_BG_TYPE_INFO:
    "Die Verfügbarkeit eines Tagesordnungspunkts bestimmt, wie oft der Tagesordnungspunkt verfügbar ist. Entweder spezifisch für bestimmte Tage oder einen Tag oder wiederholt, wenn sich der Tagesordnungspunkt wiederholt.",
  EVENT_DATES_SEL_INFO:
    "Die 'Auswahl der Daten' sind die Daten, an denen der spezifische Tagesordnungspunkt abgehalten wird. Es sind mehrere Tage als Eingabe möglich. Mehrere Tage als Eingabe sind möglich.",
  EVENT_DAYS_SEL_INFO:
    'Die "Auswahl der Tage" sind die Tage, an denen der sich wiederholende Tagesordnungspunkt abgehalten wird. Mehrere Tage als Eingabe sind möglich.',
  EVENT_START_DATE_INFO:
    "Das 'Startdatum' ist das Startdatum, an dem der Tagesordnungspunkt gehalten wird",
  EVENT_END_DATE_INFO:
    "Das „Enddatum“ ist das Enddatum, an dem der Tagesordnungspunkt abgehalten wird",
  EVENT_START_TIME_INFO:
    "Die 'Startzeit' ist die Startzeit des Tagesordnungspunkts.",
  EVENT_END_TIME_INFO: "Die 'Endzeit' ist die Endzeit des Tagesordnungspunkts.",
  EVENT_INTERVAL_INFO:
    "Das Intervall ist die Dauer (in Minuten) zwischen dem Ende eines einzelnen Tagesordnungspunkts und dem Beginn des nächsten einzelnen Tagesordnungspunkts",
  EVENT_DURATION_INFO:
    "Die Dauer des Tagesordnungspunkts ist die Länge (in Minuten) eines einzelnen Tagesordnungspunkts, die mehrmals am Tag festgelegt werden kann.",
  EVENT_MAXINFLOW_INFO:
    'Der "maximale Zufluss" ist die maximale Anzahl von Personen, die gleichzeitig den Standort betreten können',
  EVENT_PRICE_INFO:
    "Der 'Veranstaltungspreis' ist der Preis, den ein Besucher für diesen Tagesordnungspunkt zahlen muss.",
  EVENT_RATE_PRICE_INFO:
    'Der "Preis" ist der Preis, den Sie bereit sind, zusätzlich zu zahlen, wenn der Tagesordnungspunkt einem Besucher vorgeschlagen wird.',
  EVENT_REWARD_POINTS_INFO:
    "Die 'Belohnungspunkte' sind die Punkte, die ein Besucher erhalten kann, wenn der Besucher diesen Tagesordnungspunkt bucht.",
  // Event communication screen
  EVENT_MSG_TITLE_INFO: "Der 'Nachrichtentitel' ist der Titel der Nachricht.",
  EVENT_MSG_TEXT_INFO: "Der 'Nachrichtentext' ist der Text der Nachricht.",
  EVENT_MSG_RWD_LVL_INFO:
    "Jedes Ereignis hat drei Belohnungsstufen. Klicken Sie auf eine der Belohnungsstufen, um die Benutzer anzugeben, an die eine Nachricht gesendet werden soll.",
  EVENT_MSG_USER_SEL_INFO:
    "Sie können eine Nachricht an die abonnierten Benutzer für das Ereignis, die nicht abonnierten Benutzer oder an beide senden.",
  EVENT_MSG_DATE_INFO:
    "Wählen Sie das Datum, an dem Sie die Nachricht senden möchten.",
  EVENT_MSG_TIME_INFO:
    "Wählen Sie die Zeit, zu der Sie die Nachricht senden möchten.",
  EVENT_MSG_COMM_TYPE_INFO:
    "Wählen Sie den Plattformtyp der Kommunikation für die zu sendende Nachricht.",

  NEW_QUADRANT: "Neuen Quadranten erstellen",
  TYPE_QUADRANT: "Art des Quadranten",
  TYPE_OBJECT: "Objekt",
  SELECT_SIGNALS: "Signale auswählen",
  NO_INCIDENT: "Kein Vorfall",
  CONFIRM: "Bestätigen",
  SELECTED_EVENT: "Ausgewähltes Ereignis",
  QUADRANT_DESC: "Quadrantenbeschreibung",
  MAP_QUADRANT_DESC:
    "Der Kartenquadrant verwendet die Standortdetails, um die Details und die Position für den ausgewählten Standort anzuzeigen.",
  EVENT_QUADRANT_DESC:
    "Der Ereignisquadrant verwendet die Zeitschlitze eines Ereignisses, um die Details und die Kapazitätsinformationen des ausgewählten Ereignisses zu visualisieren.",
  INCIDENT_QUADRANT_DESC:
    "Der Vorfallquadrant visualisiert die Vorfälle eines ausgewählten Ortes.",
  PRODUCTCAL_QUADRANT_DESC:
    "Der Produktkalender-Quadrant verwendet Mietereignisse, um den Kalender der mit dem Ereignis verknüpften Produkte anzuzeigen.",
  EVENTCAL_QUADRANT_DESC:
    "Der Ereigniskalender-Quadrant visualisiert den Kalender für das ausgewählte Ereignis.",
  LEGENDA_GREY: "Graue Buchungen: ",
  LEGENDA_RED: "Rote Buchungen: ",
  LEGENDA_BLUE: "Blaue Buchungen: ",
  LEGENDA_YELLOW_BORDER: "Buchungen mit gelbem Rand: ",
  LEGENDA_QUADRANT_GREY:
    "Die grauen Buchungen sind externe Buchungen und enthalten keine Informationen.",
  LEGENDA_QUADRANT_RED:
    "Die rot gefärbten Buchungen sind Sperrdaten. Diese Daten sind für Benutzer nicht buchbar.",
  LEGENDA_QUADRANT_BLUE:
    "Die blau gefärbten Buchungen werden über unsere Plattform gebucht. Alle Informationen sind verfügbar.",
  LEGENDA_QUADRANT_YELLOW_BORDER:
    "Wenn ein Buchungen einen gelben Rand hat, bedeutet dies, dass das Buchung über mehrere Tage verteilt ist.",
  LEGENDA_RESTRICTIONS:
    "Wenn sich der Kalender in der Wochenansicht befindet, gibt es eine Einschränkung für die Anzeige mehrerer Buchungen an einem Tag",
  BASIC_QUADRANT_DESC:
    "Bitte wählen Sie einen Quadrantentyp aus, um die Beschreibung anzuzeigen.",

  // For helper info in webshopoverview quadrant
  WEBSHOP_QUADRANT_RED_HEADER: "Red bookings: ",
  WEBSHOP_QUADRANT_RED_DETAILS:
    "The red colored bookings are booking that need to be processed by partners before customers can proceed with bookings.",
  WEBSHOP_QUADRANT_BLUE_HEADER: "Blue bookings: ",
  WEBSHOP_QUADRANT_BLUE_DETAILS:
    "The blue colored bookings are booking that have already requested payment to customers.",
  WEBSHOP_QUADRANT_ORANGE_HEADER: "Orange bookings: ",
  WEBSHOP_QUADRANT_ORANGE_DETAILS:
    "The orange colored bookings are booking that are waiting for payments by customers.",
  WEBSHOP_QUADRANT_GREEN_HEADER: "Green bookings: ",
  WEBSHOP_QUADRANT_GREEN_DETAILS:
    "The green colored bookings are booking that have already been confirmed or done by customers.",
  WEBSHOP_QUADRANT_GREY_HEADER: "Grey bookings: ",
  WEBSHOP_QUADRANT_GREY_DETAILS:
    "The grey colored bookings are bookings that are cancelled by customers.",

  //Batchgroup

  BATCHGROUP_NAME: "Name der Chargengruppe",
  BATCHGROUP_EDIT: "Batchgruppe bearbeiten",
  BATCHGROUP_DELETE: "Batchgruppe löschen",
  BATCHGROUP_CONF_DELETE: "Möchten Sie die Stapelgruppe wirklich löschen: ",
  BATCHGROUP_DESCRIPTION: "Beschreibung der Chargengruppe",
  BATCHGROUP_CHAINBOX: "Die Chargengruppe enthält verkettbare Chargen",
  BATCHGROUP_STARTTIME: "Startzeit der Batchgruppe",
  BATCHGROUP_ENDTIME: "Endzeit der Batchgruppe",
  BATCHGROUP_STARTDATE: "Startdatum der Batchgruppe",
  BATCHGROUP_ENDDATE: "Enddatum der Batchgruppe",
  BATCHGROUP_DATES: "Daten der Chargengruppe",
  BATCHGROUP_INTERVAL: "Die Chargen beginnen alle .... (min)",
  BATCHGROUP_INTERVAL_END: "Chargen enden alle .... (min)",
  BATCHGROUP_CAPACITYPERBATCH: "Capacity per batch",
  BATCHGROUP_DURATION: "Dauer der Charge",
  BATCHGROUP_TYPERE: "Wiederholen von Zeitfenster (s)",
  BATCHGROUP_ADD: "Batchgruppe hinzufügen",
  BATCHGROUP_DETAILS: "Chargengruppendetails",
  BATCHGROUP_CHOOSETYPE: "Wählen Sie einen Stapelgruppentyp",
  BATCHGROUP_DAYS: "Wählen Sie die Tage aus, an denen das Ereignis auftritt",
  BATCHGROUP_NOPASTDATE:
    "Bitte wählen Sie ein Datum, das nicht in der Vergangenheit liegt",
  BATCHGROUP_TYPESP: "Bestimmte Daten",

  //External calendar
  EXTERNAL_CALENDAR: "Externer Kalender",
  EXTERNAL_CALENDAR_ADD: "Externen Kalender hinzufügen",
  EXTERNAL_CALENDAR_DELETE: "Externen Kalender löschen",
  EXTERNAL_CALENDAR_CONF_DELETE:
    "Möchten Sie den folgenden Kalender wirklich löschen: ",

  //Products
  PRODUCT_CATEGORIES: "Produktkategorien",
  PRODUCT_CATEGORY_EXPLANATION:
    "Um eine Produktkategorie für diese Veranstaltung hinzuzufügen, speichern Sie bitte zuerst die Veranstaltung!",
  PRODUCT_ADD_CATEGORY: "Produktkategorie hinzufügen",
  PRODUCT_IN_STOCK: "auf Lager",
  PRODUCT_DELETE: "Delete product",
  PRODUCT_ASPECT_DELETE: "Aspekt löschen",
  PRODUCT_ITEM_DELETE: "Item löschen",
  PRODUCT_PRICE_CATEGORY_DELETE: "Preiskategorie löschen",
  PRODUCT_CONF_DELETE: "Möchten Sie dieses Produkt wirklich löschen:",
  PRODUCT_ASPECT_CONF_DELETE: "Möchten Sie diesen Aspekt wirklich löschen:",
  PRODUCT_ITEM_CONF_DELETE:
    "Möchten Sie das ausgewählte Element wirklich löschen? ",
  PRODUCT_PRICE_CATEGORY_CONF_DELETE:
    "Möchten Sie die ausgewählte Preiskategorie wirklich löschen?",
  VIEW_PRODUCT: "Produkt anzeigen",
  CREATE_PRODUCT: "Ein Produkt erstellen",
  PRODUCT_NAME: "Produktname",
  PRODUCT_PRICE: "Preis des Produktes",
  PRODUCT_DESCRIPTION: "Beschreibung des Produkts",
  PRODUCT_VAT: "MwSt.% Des Produktes",
  PRODUCT_BRAND: "Markenname des Produkts",
  PRODUCT_PICTURE: "Bild des Produktes",
  PRODUCT_CATEGORIES: "Kategorien des Produkts",
  PRODUCT_CAPACITY: "Produktkapazität",
  PRODUCT_AGE: "Mindestalter für das Produkt",
  PRODUCT_CATEGORY: "Produktkategorie",
  PRODUCT_TYPE: "Type of the product",

  // Rental
  RENTAL_PERIOD: "Wähle ein Datum",
  CHECK_AVAILABILITY: "Zeitrauminformationen speichern",

  //Linda input
  LINDA_SUGGESTIONS_DIALOG: "Linda bekommt die Vorschläge",
  LINDA_FOOD_AND_BEVERAGE:
    "Hier können Sie vor oder nach Ihrer Veranstaltung Speisen und Getränke hinzufügen",
  LINDA_ADD_FOOD_BEFORE:
    "Fügen Sie vor Ihrer Veranstaltung Speisen und Getränke hinzu",
  LINDA_ADD_FOOD_AFTER:
    "Fügen Sie nach Ihrer Veranstaltung Speisen und Getränke hinzu",
  LINDA_SEARCHING: "Linda is searching for your selected event",
  LINDA_LOGIN_WELCOME: "Willkommen, ich heiße Linda.",
  LINDA_LOGIN_HELPING_HAND:
    "Ich werde Ihnen helfen, einen Tag zu planen, um sicherzustellen, dass Sie das Maximum aus Ihrem Tag herausholen und die Massen umgehen.",
  LINDA_LOGIN_SHORT_INFO:
    "Mit Linda können Sie innerhalb von 5 Minuten einen Termin vereinbaren. Mit diesem Termin sorgt Linda dafür, dass Ihr Tag nachlässig und verkehrsfrei ist.",
  LINDA_WELCOME: "Herzlich willkommen!",
  LINDA_REGISTER_USERINFO:
    "Zu Beginn benötige ich einige Informationen, damit ich weiß, für wen ich plane.",
  LINDA_REGISTER_LATER:
    "This way i can notice you in a later stage for your appointment.",
  LINDA_REGISTER_DONE: "Danke für die Registrierung",
  LINDA_REGISTER_MAIL:
    " Fertig! Vielen Dank, dass Sie Ihren accountName-Pass erstellt haben. Wir haben Ihnen eine Bestätigungs-E-Mail mit einem Link zur Aktivierung Ihres Reisepasses gesendet. Bitte klicken Sie auf den Link, um Ihren Reisepass zu aktivieren. Überprüfen Sie Ihren Spam-Ordner, falls Sie die Bestätigungs-E-Mail nicht erhalten haben. ",

  LINDA_BIGGER_GAP_OR_GROUPSIZE:
    "Versuchen Sie, die Zeitlücke zu vergrößern und / oder die Gruppengröße zu verkleinern.",
  LINDA_ACCOUNT_CREATION_FIRST_STEP: "Großartig! Ihr Konto wurde erstellt",
  LINDA_ACCOUNT_CREATION_FIRST_STEP_DESC:
    "Ich habe dir eine E-Mail mit einem Link geschickt.\n" +
    "Klicken Sie auf den Link in Ihrer E-Mail, um Ihr Konto zu aktivieren",
  LINDA_ACCOUNT_CREATION: "Herzlich willkommen!",
  LINDA_WELCOME_BACK: "Willkommen zurück!",
  LINDA_ACCOUNT_READY_TO_CREATE:
    "Zunächst muss ich wissen, wer Sie sind, damit ich ein Konto für Sie erstellen kann.",
  LINDA_USER_TRIPLIST:
    "Sehen Sie sich Ihre Termine an oder erstellen Sie einen neuen. Sie können Ihre Tickets abrufen, indem Sie auf einen Termin klicken.",
  LINDA_WHERE_TO: "Wohin willst du gehen?",
  LINDA_SEARCH_EVENT: "Wählen Sie ein Ereignis aus, um fortzufahren",
  LINDA_DATE_PICKER_WELCOME: "Okay, lass uns ein Datum auswählen.",
  LINDA_DATE_PICKER: "Wann planen Sie zu gehen?",
  LINDA_SPECIAL_CODE: "Haben Sie per Post einen VIP-Code erhalten?",
  LINDA_TRIP_DETAIL:
    "Mit wem wollen Sie gehen und zu welcher Zeit werden Sie wohl ankommen und gehen?",
  LINDA_ACTIVITY_LIST:
    "Ich möchte eine Liste der Aktivitäten erstellen, die Sie sehen und ausführen möchten. Auf diese Weise stelle ich sicher, dass Sie sicher alle besuchen können.",
  LINDA_ADJUST_INFO:
    "Diese Informationen können zu einem späteren Zeitpunkt angepasst werden.",
  LINDA_MODE_OF_TRANSPORT: "Wie planen Sie zu reisen?",
  LINDA_SAVING_A_SPOT:
    "Auf diese Weise kann ich Ihnen helfen, einen Parkplatz zu retten oder zu überprüfen, ob öffentliche Verkehrsmittel / Shuttlebusse verfügbar sind.",
  LINDA_CHECK_INPUT:
    "Bitte überprüfen Sie alle Daten, damit wir sicherstellen können, dass nichts schief geht.",
  LINDA_MEETING_SET: "Der Buchungsvorgang ist abgeschlossen",
  LINDA_MEETING_SET2:
    "Ihre Buchungsanfrage wurde zur Bestätigung an unseren Partner weitergeleitet.",
  LINDA_ERROR: "Etwas ist schief gelaufen.",
  LINDA_ERROR_PAYMENT:
    "Ihre Zahlung wurde nicht erhalten. Überprüfen Sie Ihr Konto",
  LINDA_ADJUST_TIME:
    "Sie können die Zeit und das Transportmittel ändern, wenn es nicht mehr korrekt ist.",
  REGISTER_LINDA: "Registrieren",
  LINDA_EVENT_NAME: "Wählen Sie eine Veranstaltung",
  LINDA_VIP: "Rabattcode",
  LINDA_VIP_DIALOG:
    "Wenn Sie einen Rabattcode in Ihrer E-Mail erhalten haben, geben Sie diesen bitte unten ein oder klicken Sie auf Weiter.",
  LINDA_USERGROUP_DIALOG:
    "Wenn Sie einen speziellen Code erhalten haben, geben Sie diesen bitte unten ein",
  LINDA_VIP_INPUT: "Bitte geben Sie hier Ihren Rabattcode ein",
  LINDA_GROUP_SIZE: "Gruppengröße",
  LINDA_GS_INPUT: "Gruppengröße festlegen",
  LINDA_ARRIVAL: "Erwartete Ankunft",
  LINDA_ARRIVAL_LABEL: "Arrival time",
  LINDA_DEPARTURE_LABEL: "Abfahrtszeit",
  LINDA_DEPARTURE: "Voraussichtliche Abreise",
  LINDA_TRANSPORT_TYPE: "Transportart",
  LINDA_ATTEND: "Was möchtest du besuchen?",
  LINDA_NO_SUBEVENTS: "Es sind keine Unterereignisse verfügbar",
  LINDA_FILL_REQUIRED: "Please fill in all the required fields",
  LINDA_NEW_APPOINTMENT: "Neuer Termin",
  LINDA_APPOINTMENTS: "Ihre Termine",
  LINDA_NO_APPOINTMENTS: "Keine Termine",
  LINDA_GO_TO_APPOINTMENTS: "Gehe zu meinen Aktivitäten ",
  LINDA_ORDER: "Deine Bestellung",
  LINDA_STARTTIME: "Startzeit",
  LINDA_ENDTIME: "Endzeit",
  LINDA_DELETE_APPOINTMENT: "Möchten Sie den Termin wirklich löschen?",
  LINDA_CALENDAR_CROWDED: "Überfüllt ",
  LINDA_CALENDAR_CALM: "Ruhe ",
  LINDA_CALENDAR_AVERAGE: "Durchschnittlich ",
  LINDA_CALENDAR_SELECTED: "Ausgewählt ",
  LINDA_TRANSPORT_MODE: "Transportart",
  LINDA_NO_TRANSPORT_AVAILABLE: "Es ist kein Transportmittel verfügbar",
  LINDA_MANDATORY_TRANSPORT:
    "Bitte wählen Sie ein Transportmittel, um fortzufahren",
  LINDA_TOTAL_PRICE: "Gesamtpreis",
  LINDA_CANCEL_ORDER: "Stornieren",
  LINDA_CONFIRM_ORDER: "Bestätigen",
  LINDA_ORDER_FAILED:
    "Der Termin wurde gelöscht. Weitere Anweisungen finden Sie in Ihrer E-Mail.",
  CLOSE: "Schließen",
  LINDA_REGISTER_TO: "Registrieren Sie sich für ...",
  LINDA_MISS_NOTHING: "Nichts vermissen",
  LINDA_OWN_PROGRAM: "Erstellen Sie Ihr eigenes Programm",
  LINDA_AVOID: "Vermeiden Sie Warteschlangen",
  LINDA_PLAN_VISIT: "Planen Sie Ihren Besuch mit Linda",
  LINDA_ENJOY: "In vollen Zügen genießen",
  LINDA_ADVANTAGE: "Profitieren Sie von Extras und Rabatten",
  LINDA_ACCOUNT_MADE_TITLE:
    "Großartig! Das Konto wird erstellt. Um das Konto zu aktivieren, benötige ich den Stil Ihres Unternehmens.",
  LINDA_ACCOUNT_MADE_BODY:
    "Ich werde sicherstellen, dass Ihr Konto so aussieht, als ob es Ihnen gehört",
  LINDA_NONE: "Keiner",
  LINDA_PLANNED_SUCCESSFULL: "Eine Bestätigungs-E-Mail wurde gesendet",
  LINDA_PLANNED_SUCCESSFULL2:
    "Sie erhalten eine Nachricht, wenn der Partner Ihre Buchungsanfrage bestätigt oder abgelehnt hat.",
  LINDA_KEEPS_PROMISE: "Den Termin finden Sie in meinen Aktivitäten§",
  LINDA_TICKETS_TO_MAIL:
    "Ich habe die Tickets per Post an Ihr Mail-Konto gesendet!",
  LINDA_TICKET_INFO_ACCOUNT:
    "Sie können die Tickets auch abrufen, indem Sie auf die Informationen Ihres Termins klicken.",
  LINDA_BG_MEANING:
    "Um die Benutzer auf Ihre Einrichtungen zu verteilen, müssen Sie Stapelgruppen erstellen. Diese Chargengruppen bestehen aus verschiedenen Chargen.",
  LINDA_BG_FILLING:
    "Damit kann ich die Benutzer für verschiedene Chargen einplanen und sicherstellen, dass alle Chargen gut gefüllt sind.",
  LINDA_THEME: "Thema",
  LINDA_GETTING_EVENTS: "Linda bekommt die Ereignisse",
  LINDA_CHECK_YOUR_ORDER: "Überprüfen Sie Ihre Auswahl",
  LINDA_PLEASE_FILL_IN: "Bitte füllen Sie die Felder aus",

  //Web stepper two

  STEP_THEME: "Thema auswählen",
  STEP_DETAILS: "Reisedetails",
  STEP_WISHLIST: "Wunschzettel",
  STEP_PLAN: "Planen Sie Ihren Tag",
  STEP_TRANSPORT: "Transportmodus",
  STEP_ISSUES: "Probleme",
  STEP_CONFIRM: "Bestätigung",

  PREVIOUS: "Bisherige",
  CONTINUE: "Fortsetzen",
  NEXT: "Nächster",
  CANCEL: "Stornieren",
  CANCEL_TOOLTIP: "Stornieren",
  LOGIN: "Anmeldung",
  USERNAME: "Nutzername",
  PASSWORD: "Passwort",
  LOGIN_TEXT: "Hast du schon einen Account?",
  REGISTER_TEXT: "Ein Konto erstellen",
  ACTIVATION_CODE_REQUIRED: "Aktivierungscode ist erforderlich",
  ACTIVATION_CODE_TITLE: "Aktivierungscode: Erstellen Sie Ihr Konto. ",
  ACTIVATION_CODE_TEXT:
    "Bitte geben Sie den Aktivierungscode ein, den Sie nach dem Erstellen Ihres Kontos per E-Mail erhalten haben. ",
  ACTIVATION_CODE_INPUT: "Geben Sie Ihren Aktivierungscode ein",
  ALERT:
    "Die App ist noch nicht verfügbar. Sie erhalten eine E-Mail, sobald die App zum Herunterladen verfügbar ist.",
  MAKE_ROUTE: "Route machen",

  TITLE: "Titel",
  TEXT: "Text",
  DESTINATION: "Ziel",
  ACCOUNT_PREFERENCES_SAVED_CORRECTLY:
    "Kontoeinstellungen werden korrekt gespeichert!",
  PARTNER_PREFERENCES_SAVED_CORRECTLY:
    "Partnereinstellungen werden korrekt gespeichert!",
  ACCOUNT_ALREADY_ACTIVATED: "Dein Benutzerkonto ist bereits aktiviert!",
  LOCATION_CREATION_OK: "Standort erfolgreich erstellt ",
  LOCATION_EDITING_OK: "Speicherort erfolgreich bearbeitet",
  USERGROUP_INFO_SAVED_OK:
    "Benutzergruppeninformationen wurden erfolgreich gespeichert",
  ACCOUNT_SAVED_OK: "Konto erfolgreich gespeichert",
  USERGROUP: "Benutzergruppe",
  DELETE_USERGROUP_TITLE: "Sind Sie sicher, die Benutzergruppe zu löschen?",
  ACCOUNT_MNG: "Kontoverwaltung",
  CREATE: "Erstellen",
  SEND: "Senden",
  SAVE: "speichern",
  DELETE: "Löschen",
  SAVE_TOOLTIP: "Änderungen speichern",
  SEND_VIP_CODE: "VIP-Code senden",
  SEND_USERGROUP_CODE: "Code senden",

  ONCE_ONLY_NOTIFICATION: "Nur einmalige Benachrichtigung",
  CREATE_NEW_NOTIFICATION: "Neue Benachrichtigung erstellen",
  LOCATION_NOTIFICATION: "Standortbenachrichtigungen",
  ALL_NOTIFICATION: "Alle Benachrichtigungen",
  EDIT_NOTIFICATION: "Benachrichtigung bearbeiten",

  CONFIRM_REGISTER: "Registrierung bestätigt",

  NO_ACCOUNT_ID:
    "In der URL ist keine Konto-ID angegeben, oder das Konto ist für dieses Konto nicht vorhanden",
  NO_PARTNER_ID:
    "Die Partner-ID ist ungültig oder nicht in der URL angegeben. Bitte geben Sie eine gültige Partner-ID ein.",
  ACCOUNT_NAME: "Kontobezeichnung",
  ACCOUNT_DESCRIPTION: "Account Beschreibung",
  LOCATION_OVERVIEW: "Standortübersicht",
  EVENT_OVERVIEW: "Ereignisübersicht",
  LOCATIONS: "Standorte",
  CREATE_TOUR: "Tour erstellen",
  CONFIGURE_ROUTE: "Route konfigurieren",
  SHOW_ROUTE: "Handbuch",
  SHOW_WAYPOINTS: "automatisch",
  ACCOUNT_TITLE: "Konto",
  DASHBOARD_TITLE: "Instrumententafel",
  ACCOUNT_URL: "Webadresse",
  ACCOUNT_EMAIL: "Administrator der E-Mail-Adresse",
  ACCOUNT_TITLE_AUTOCOMPLETE: "Organisation benennen",
  ACCOUNT_TITLE_CREATE_STYLE: "Kreieren Sie Ihren eigenen Stil",
  ACCOUNT_URL_AUTOCOMPLETE: "Webadresse",
  ACCOUNT_EMAIL_AUTOCOMPLETE: "Administrator der E-Mail-Adresse",
  ACCOUNT_CONFIRMATION: "Account Bestätigung",
  ACCOUNT_SELECTION_CONFIRMATION:
    "Möchten Sie Ihr Konto wirklich mit diesen Daten bestätigen?",
  ACCOUNT_CHANGES_LATER: "Sie können es später noch ändern",
  ACCOUNT_LINK: "Verknüpfung",
  ACCOUNT_MAIN_LOCATION: "Hauptstandort",
  ACCOUNT_ADMIN_NUMBER_SALE: "Verkaufsverwaltungsnummer",
  ACCOUNT_ADMIN_NUMBER_FEE: "Verwaltungskosten",
  ACCOUNT_SERVICE_PERCENTAGE: "Service-Rate",
  ACCOUNT_MAX_PREBOOKS: "Max Prebooks",
  ACCOUNT_HIGH_VAT: "Hoch VAT",
  ACCOUNT_LOW_VAT: "Niedrig VAT",
  "ACCOUNT_SALES_&_FEES": "Verkaufs- und Kosteneinstellungen für",
  ACCOUNT_BOOKNUMBER_FEE: "Buchnummer Gebühren",
  ACCOUNT_JOURNAL_NUMBER_SALES: "Journalnummer Vertrieb",
  ACCOUNT_JOURNAL_NUMBER_FEES: "Journalnummer Gebühren",
  ACCOUNT_NAME_OF_FILE: "Name der Datei",
  ACCOUNT_MONTHLY_FEE_GENERATION_DAY: "Tag der monatlichen Gebühr",
  ACCOUNT_GENERATION_DAY: "Generationentag",
  ACCOUNT_SAVE_SALES_FEE:
    "Bitte speichern Sie die Einstellungen für Umsatz und Kosten, bevor Sie auf die folgenden Schaltflächen klicken.",
  ACCOUNT_BOTH_BUTTONS: "Beide Tasten werden auf Rechnung aufgerufen",
  ACCOUNT_GENERATE_SALES_FEES: "Verkaufskosten generieren",
  ACCOUNT_GENERATE_MONTHLY_FEES: "Generieren Sie monatliche Kosten",
  ACCOUNT_USERGROUP_NAME: "Benutzergruppenname",
  ACCOUNT_NEW_USERGROUP: "Neue Benutzergruppe",
  ACCOUNT_EDIT_USERGROUP: "Benutzergruppe bearbeiten",

  ACCOUNT_USER_ROLE_DESCRIPTION: "User Role",
  ACCOUNT_USER_ROLE_PARTNER: "Partner",
  ACCOUNT_NEW_USER_ROLE: "New User Role",
  ACCOUNT_EDIT_USER_ROLE: "Edit User Role",
  ACCOUNT_USER_ROLE_GLOBAL: "Global",
  DELETE_USER_ROLE_TITLE: "Are you sure to delete the User Role?",
  UR_FOR_USER: "Available user roles",

  ACCOUNT_USER_STATE: "Benutzerstatus",
  ACCOUNT_USER_ID: "Benutzer ID",
  ACCOUNT_DELETE_USER: "Sind Sie sicher, dass Sie den Benutzer löschen möchten",
  ACCOUNT_VAT_NUMBER: "VAT nummer",
  ACCOUNT_VAT_BTW: "Partner VAT nummer (BTW)",
  ACCOUNT_CAMPAIGN_BUDGET: "Budgetkampagne",
  ACCOUNT_PARTNER_SUPPLIER_CODE: "Partner-Lieferantencode",
  ACCOUNT_SUPPLIER_CODE: "Lieferantencode",
  // Tool Bar
  FINANCIAL_MANAGEMENT: "Finanzverwaltung",
  FINANCIAL: "Finanziell",
  THEME_LIST: "Startseite",
  THEMES: "Höhepunkte",
  STATISTICS: "Statistiken",

  //home
  REGISTER: "Registrieren",
  REGISTER_HEAD: "Verpassen Sie nichts ",
  WHY_REGISTER:
    "Warum registrieren für " + appConfig.dss.environmentName + "-app?",
  REGISTER_LIST:
    "Genieß das " +
    appConfig.dss.environmentName +
    " in vollem Umfang mit diesen Vorteilen nur für App-Benutzer.",
  //'REGISTER_LIST':'Met de app geniet je maximaal van de '+appConfig.dss.environmentName+'! Meld je aan, download de app en mis niets van dit stijlvolle evenement. ',
  REGISTER_LIST_1:
    "Wir halten Sie über Ihre Lieblingsveranstaltungen auf dem Laufenden.",
  REGISTER_LIST_2: "Gewinne tolle Preise.",
  REGISTER_LIST_3: "Kaufen Sie Ihr Parkticket online.",
  REGISTER_LIST_4: "Erhalten Sie Sonderangebote und Rabatte.",
  REGISTER_LIST_5: "Finden Sie einfach Ihren Weg mit der praktischen Karte.  ",
  REGISTER_LIST_6:
    "Registrieren Sie sich für ein Konto und laden Sie das herunter " +
    appConfig.dss.environmentName +
    " im Apple App Store oder bei Google Play.",
  REGISTER_NOW: "Jetzt registrieren",
  //register
  REGISTER_DETAILS: "Ein Konto erstellen",
  REGISTER_DETAILS_INFO:
    "Bitte geben Sie uns einige persönliche Daten, damit wir ein Konto für Sie erstellen können",
  REGISTER_INFO: "Warum fragen wir nach diesen Informationen?",
  REGISTER_PHONE: "Handynummer: ",
  REGISTER_PHONE_TEXT:
    "Wir werden Sie mit Textnachrichten auf dem Laufenden halten, wenn es ein Problem mit der App gibt.",
  REGISTER_VIP: "Sondercode ",
  REGISTER_VIP_TEXT:
    "Haben Sie einen Code von der erhalten? " +
    appConfig.dss.environmentName +
    " Organisation? Bitte gebe es hier ein. Ansonsten lassen Sie bitte das Feld leer. ",
  REGISTER_ZIPCODE: "Postal code: ",
  REGISTER_ZIPCODE_TEXT:
    "Früher haben wir Einblicke erhalten, woher unsere Besucher kommen, damit wir mehr Sponsoren gewinnen und die Veranstaltung für Besucher kostenlos halten können. ",
  REGISTER_LICENSE: "Nummernschild: ",
  REGISTER_LICENSE_TEXT:
    "Wenn Sie mit dem Auto anreisen, geben Sie Ihr Nummernschild ein, um schnell zum Parkplatz zu gelangen. ",
  REGISTER_CHECKBOX: "Ich stimme dem zu",
  REGISTER_PRIVACY_STATEMENT: "Datenschutzerklärung",
  REGISTER_KEEP_ME_UP_TO_DATE:
    "Ja, bitte halten Sie mich auf dem Laufenden " +
    appConfig.dss.environmentName +
    "",
  REGISTER_FORM_NAME: "Name",
  REGISTER_FORM_LASTNAME: "Nachname",
  REGISTER_FORM_EMAIL: "Email",
  REGISTER_FORM_PHONE: "Handynummer",
  REGISTER_FORM_ZIP: "Postleitzahl",
  REGISTER_FORM_COUNTRY: "Wähle ein Land",
  REGISTER_FORM_VIP: "Sondercode",
  REGISTER_FORM_LICENSE: "Nummernschild",
  REGISTER_ACCOUNT: "Registrieren Sie einen Account",
  REGISTER_INTEREST_TITLE: "Interessen",
  REGISTER_INTEREST:
    "Teilen Sie uns mit, woran Sie interessiert sind, damit wir Ihnen bevorstehende Veranstaltungen anbieten können, die Ihren Interessen entsprechen",
  REGISTER_ACCOMPANY:
    "Lassen Sie uns wissen, wer Sie begleitet, damit wir Ihnen bei der Auswahl geeigneter Veranstaltungen helfen können.",
  REGISTER_ACCOMPANY_TITLE: "Ich werde mit besuchen",

  GRAPH_0_LABEL_0: "Ist eingetroffen",
  GRAPH_0_LABEL_1: "Erwartet",
  GRAPH_0_OPT: "Bezoekers",
  GRAPH_N_ARRIVALS: "Anzahl der Ankünfte",
  GRAPH_N_ARRIVALS_OPT: "Optimierte Anzahl der Ankünfte",
  GRAPH_N_DEPARTURE_OPT: "Optimierte Anzahl der Abfahrten",
  GRAPH_N_DEPARTURE: "Anzahl der Abfahrten",

  GRAPH_0: "Gesamt",
  GRAPH_1: "Fest",
  GRAPH_2: "Biegen",
  GRAPH_3: "Locker",
  GRAPH_4: "Warteschlangenlänge",
  GRAPH_5: "Aktuell",

  EVENT_GRAPH_ORDER_TYPE:
    "Das ausgewählte Ereignis verfügt möglicherweise über eine Zustellungs- und eine Mitnahmeoption. Wählen Sie eine aus (falls möglich), um das Diagramm anzuzeigen:",
  EVENT_GRAPH_SELECT_ORDER_TYPE: "Bitte wählen Sie die Bestellart",
  EVENT_GRAPH_DATE_PICKER:
    "Wählen Sie ein Datum aus, um die erwarteten Besucherzahlen basierend auf der Anzahl der Reservierungen an diesem Tag anzuzeigen",
  EVENT_GRAPH_DETAILS: "erwartete Menschenmengen",

  ERROR_EVENT2_01: "Ankünfte überschreiten die Kapazität dieser Veranstaltung",
  ERROR_EVENT2_02:
    "Warteschlangenlänge oder Wartezeit überschreiten den Schwellenwert ",

  ERROR_DESTINATION_01: "Datenbankverbindungsfehler",
  ERROR_DESTINATION_02: "PushNotificationBridge-Verbindungsfehler",
  ERROR_DESTINATION_03:
    "Ereignis in der Vergangenheit neu planen (nicht möglich)",
  ERROR_DESTINATION_04:
    "Inkonsistente Ereignisdaten (Zeitfenster, in dem endTime <= startTime)",
  ERROR_DESTINATION_05:
    "Maximale Kapazität überschritten (beim Versuch, ein Ereignis neu zu planen)",
  ERROR_DESTINATION_06:
    "Keine Belohnung konfiguriert (beim Abschluss eines Ereignisses oder beim Auslösen einer Verhandlungsrunde)",
  ERROR_DESTINATION_07: "Endzeit - Startzeit größer als die Intervalldauer",
  ERROR_DESTINATION_08: "Das übergeordnete Objekt ist nicht vom Typ Ziel",
  ERROR_DESTINATION_09: "Übergeordnetes Objekt null",
  ERROR_DESTINATION_10: "Aktuelles Objekt null",
  ERROR_DESTINATION_11: "Ereignis in der Vergangenheit zurückgesetzt",
  ERROR_DIT_01:
    "Keine Belohnung konfiguriert (beim Abschluss eines Ereignisses oder beim Auslösen einer Verhandlungsrunde)",
  ERROR_DIS_01:
    "Keine Belohnung konfiguriert (beim Abschluss eines Ereignisses oder beim Auslösen einer Verhandlungsrunde)",
  ERROR_DIT_02: "Dit Thread läuft bereits",
  ERROR_EVENT_01: "Übergebene Ereignis-ID nicht korrekt bestanden",
  ERROR_EVENT_02: "Übergebene Steckplatz-ID nicht korrekt",

  REGISTER_VISIT_WITH:
    "ich werde besuchen " + appConfig.dss.environmentName + " mit",
  REGISTER_MYSELF: "Myself",
  REGISTER_PARTNER: "Meine Partnerin",
  REGISTER_FRIENDS: "Freunde",
  REGISTER_KIDS: "Kinder",
  REGISTER_SCHOOL: "Schule",

  SUCCES_REGISTER: "Hurra! Ihr Konto wurde erstellt",
  // 'SUCCES_REGISTER_TEXT_1': 'Congratulations! Please continue to the next step and let us know which days you will be visiting the event. You can also purchase a parking ticket for Saturday June 30th online if needed.  ',
  SUCCES_REGISTER_TEXT_1:
    "Sie haben eine E-Mail mit einem Link zur Aktivierung Ihres Kontos erhalten",
  SUCCES_REGISTER_TEXT_2:
    "Hier ist Ihre eindeutige Benutzer-ID. Verwenden Sie diese Option, um die App nach dem Herunterladen im Apple App Store oder bei Google Play zu aktivieren. Sie erhalten außerdem Ihre Benutzer-ID in Ihrer E-Mail mit Anweisungen zum Aktivieren der App.",
  SUCCES_REGISTER_USER_ID: "Ihre Benutzer-ID:",
  DOWNLOAD: "Laden Sie die App herunter",
  APPLE: "für Apple",
  ANDROID: "für Android",

  APPLY: "Anwenden",

  TAGS: "Stichworte",
  TAGS_EVENT: "Wählen Sie Ihre Lieblings-Tags aus",
  TAGS_TEXT:
    "Bitte wählen Sie die Tags aus, die Ihnen gefallen, damit wir Ihnen Ereignisse im Zusammenhang mit diesen Tags anzeigen können.",
  TAGS_REQ: "Bitte wählen Sie die Tags aus",

  //Ticket
  TICKET_NEW: "Neuer Ticket-Typ",
  TICKETS_PRICING_EXPLANATION:
    "Da die Preisgestaltung extern verwaltet wird, besteht keine Möglichkeit, ein Ticket hinzuzufügen",
  TICKET_SOME_EXPLANATION: "Einige Erklärungen zu den Ticketarten",
  TICKET: "Tickets",
  TICKET_EVENT: "Wählen Sie Ihre Lieblingsereignisse",
  TICKET_TEXT:
    "Bitte wählen Sie die Tage aus, an denen Sie uns besuchen, damit wir Sie über Ihre Lieblingsveranstaltungen auf dem Laufenden halten können. Sie können auch sofort Tickets für bezahlte Veranstaltungen kaufen.",
  TICKET_WARNING: "bitte beachten Sie",
  TICKET_TEXT_1:
    " Das Parken wird am Samstag, den 30. Juni bezahlt. Kaufen Sie Ihr Ticket online, indem Sie rechts „Parken“ auswählen. Mit einem Online-Ticket können Sie die Warteschlange überspringen und den Aufwand der Barzahlung vermeiden.",
  TICKET_TEXT_2:
    "Die gekauften Tickets sind nicht erstattungsfähig und nicht übertragbar. Sie erhalten Ihre Tickets von 30 Minuten nach Abschluss des Zahlungsvorgangs per E-Mail. ",
  TICKET_TEXT_3: "Durch den Online-Kauf Ihrer Tickets stimmen Sie unseren zu",
  TICKET_TEXT_TERMS: "allgemeine Begriffe.",
  TICKET_ATTEND: "An welchen Tagen möchten Sie teilnehmen?",
  TICKET_ARRIVING: "Wann kommen Sie an?",
  TICKET_INFORMATION: "Tickets werden von der Eventorganisation bearbeitet.",
  TICKET_INFORMATION2: "Am Standort kann eine Eintrittsgebühr erhoben werden.",

  //Linda output
  TRIPS: "Reisen",
  TRIP_WELCOME: "Willkommen in Ihrer Triplist",
  TRIP_CHOICE:
    'Bitte wählen Sie eine Reise in Ihrer speziellen Dreifachliste aus, um sie anzuzeigen oder zu löschen. Wenn Ihre Dreierliste keine Reise enthält, können Sie eine Reise für dieses Ereignis erstellen, indem Sie auf das Symbol "+" in der oberen rechten Ecke klicken.',
  TRIP_STARTED: "Lassen Sie uns Ihre Reise personalisieren",
  TRIP_EVENT_PICKER:
    "Bitte wählen Sie aus den folgenden Veranstaltungen eine Auswahl aus. Wenn Sie einen weiteren Tag für dieselbe Veranstaltung oder eine neue Reise hinzufügen möchten, ist dies nach Abschluss dieser Veranstaltungsregistrierung möglich!",
  TRIP_DATEPICKER:
    "Nachdem Sie nun wissen, welche Veranstaltung Sie besuchen werden, können Sie das richtige Datum für die Besichtigung der Veranstaltung auswählen. Bitte klicken Sie auf das Datum, an dem Sie die Veranstaltung besuchen möchten.",
  TRIP_PLAN: "Planen Sie meine Reise",

  PAYMENT: "Bitte bestätigen Sie Ihre Auswahl",
  PAYMENT_TEXT:
    "Bitte überprüfen Sie die folgenden Daten und bestätigen Sie Ihre Auswahl, um Ihre Ticketregistrierung abzuschließen.",
  PAYMENT_CONFIRM: "Bestätigen",
  PAYMENT_CONFIRM_PAY: "Bestätigen und zahlen",
  PAYMENT_OVERVIEW: "Veranstaltungsübersicht:",
  ARRIVAL_INFO: "Ausgewählte Veranstaltungstage:",
  ARRIVAL_TIME: "Voraussichtliche Ankunftszeit:",
  TOTAL_PRICE: "Gesamtpreis:",

  TICKET_SUCCES: "Hurra! Wir freuen uns, Sie begrüßen zu dürfen.",
  // 'TICKET_SUCCES_1': 'Your registration is successful. We’ll send you a confirmation by email.',
  TICKET_SUCCES_1:
    "Ihre Registrierung ist erfolgreich. Viel Glück und genießen Sie die " +
    appConfig.dss.environmentName +
    " !",
  TICKET_SUCCES_2:
    "Jetzt ist es Zeit, die App herunterzuladen und zu aktivieren, um die Chance auf diese schönen Preise zu haben. Viel Glück und genießen Sie die " +
    appConfig.dss.environmentName +
    " !",

  TICKET_ORDER: "Tickets bestellen",
  TICKET_ORDER_1: "Bestätige deine Bestellung",
  TICKET_ORDER_2: "",
  EVENT_PAYMENT: "Zahlungsvorgang",
  EVENT_PAYMENT_INFO:
    "Sie werden zu Mollie-Zahlungen weitergeleitet, um Ihren Zahlungsvorgang abzuschließen",
  EVENT_PAYMENT_INFO_1: "",
  TRIP_TICKETS: "Tickets herunterladen",

  PAYMENT_SUCCESS: "Zahlung erfolgreich abgeschlossen",
  PAYMENT_FAILED: "Bezahlung fehlgeschlagen",
  TO_APP_USERS:
    "Wenn Sie ein App-Benutzer sind, kehren Sie bitte zur App zurück, um fortzufahren!",

  TICKET_UNSUCCESSFUL:
    "Hoppla! Es tut uns sehr leid, aber Ihre Zahlung war nicht erfolgreich",
  TICKET_UNSUCCESSFUL_TEXT:
    "Bitte versuchen Sie es erneut. Wir sind sicher, dass dies nur eine Panne ist. Wenn dieses Problem weiterhin auftritt, wenden Sie sich an das Kundendienstzentrum von The Driving Force unter customerservice@thedrivingforce.nl oder telefonisch unter +31 297 51 44 55.",
  RETRY: "Wiederholen",

  SUCCES_PAYMENT: "Hurra! Ihre Zahlung war erfolgreich.",
  SUCCES_PAYMENT_1:
    "Ihre Registrierung ist nun abgeschlossen. Wir senden Ihnen eine Bestätigung per E-Mail mit Ihren Tickets. Wir freuen uns, Sie begrüßen zu dürfen.",
  SUCCES_PAYMENT_2:
    "Jetzt ist es Zeit, die App herunterzuladen und zu aktivieren, um die Chance auf diese schönen Preise zu haben. Viel Glück und genießen Sie die " +
    appConfig.dss.environmentName +
    ". ",
  Website_Down_1:
    "Es tut uns sehr leid, aber die Website ist vorübergehend nicht verfügbar.",
  Website_Down_2: "Wir arbeiten daran und es wird sehr bald zurück sein.",

  DRIP_OBJECT_NAME: "Name DRIP",
  DRIP_OBJECT_DESCRIPTION: "Description von DRIP",
  DRIP_LOCATION: "Klicken Sie mit der rechten Maustaste auf den DRIP",
  DRIP_IPADDRESS: "IP adres von DRIP",
  DRIP_PORT: "Port number von DRIP",
  DRIP_WINDOWNAME: "Window name von DRIP",
  DRIP_HEIGHT: "Height von DRIP",
  DRIP_BREADTH: "Width von DRIP",

  PRIS_OBJECT_NAME: "Name von PRIS",
  PRIS_OBJECT_DESCRIPTION: "Beschreibung von PRIS",
  PRIS_LOCATION: "Klicken Sie mit der rechten Maustaste auf PRIS",
  PRIS_IPADDRESS: "IP adres von PRIS",
  PRIS_PORT: "Portnummer von PRIS",
  PRIS_WINDOWNAME: "Fenstername von PRIS",
  PRIS_HEIGHT: "Höhe von PRIS",
  PRIS_BREADTH: "Breite von PRIS",

  VRI_OBJECT_NAME: "Name von PRIS",
  VRI_OBJECT_DESCRIPTION: "Beschreibung von PRIS",
  VRI_WEBSITE: "Webseite",
  VRI_IP: "IP-Adressen",
  VRI_IVERA: "Ivera",
  VRI_IVERA_NAME: "Ivera name",
  VRI_PASSWORD: "Ivera Passwort",
  VRI_ITS: "Seinen Namen",
  VRI_ITS_PASSWORD: "SEIN Passwort",
  VRI_TRIGGER_CERT: "Zertifikat auslösen",
  VRI_CERT: "VRI-Zertifikat",
  VRI_TRIGGER_IP: "IP auslösen",
  VRI_VTYPE: "V Art",
  VRI_VVERSION: "V Ausführung",
  VRI_VNAME: "V name",
  VRI_VPASSWORD: "V Passwort",
  VRI_VSOURCE: "V Quelle",
  VRI_VIP: "VIP",
  VRI_VPORT: "V Port",
  VRI_CAPACITY: "Kapazität",
  VRI_NOTES: "Anmerkungen",
  VRI_CONFIG: "Konfigurieren",
  VRI_XY: "XY",
  VRI_KPP: "KPP",
  VRI_ATTACHMENT: "Anhänge",

  NO_RELATION: "Keine Beziehungen",
  NO_TRAFFIC_OBJECTS: "Keine Verkehrsobjekte",
  NO_SENSOR_ACTUATOR: "Keine Sensoraktoren",
  NO_EVENTS: "Keine Ereignisse",
  NO_EVENTS_AVAILABLE: "Keine Veranstaltungen verfügbar",
  AVAILABLE: "Verfügbar",
  ADD_RELATION: "Beziehung hinzufügen",
  ADD_TRAFFIC_OBJECT: "Verkehrsobjekt hinzufügen",
  ADD_SENSOR_ACTUATOR: "Sensoraktor hinzufügen",
  ADD_EVENTS: "Ereignis hinzufügen",
  NO_ENTRY_EXIT_POINTS: "Keine Ein- / Ausstiegspunkte",
  ENTRY_EXIT_POINTS: "Ein- und Ausstiegspunkte ",
  INCIDENTS: "Vorfälle",
  RELATIONS: "Beziehungen",
  TRAFFIC_OBJECTS: "Verkehrsobjekt",
  SENSOR_ACTUATOR: "Sensor / Aktoren",
  SAVE_RELATION: "Beziehung speichern",

  OP_SCREEN: "Betriebsbildschirme",
  MAP_TITLE: "Karte",
  ROUTE_MAP_TITLE: "Straßenkarte",
  ROUTE_MAP_DESC:
    "Klicken Sie auf die Karte, um den Routeneditor aufzurufen. Im Routeneditor können Sie die Route anpassen, Ihrer Route Stopps hinzufügen und vieles mehr.",
  ROUTE_MAP_DESC_WARNING:
    'Wenn keine Route verfügbar ist, klicken Sie auf die Schaltfläche "Route generieren", um die Route zu erstellen.',
  TRAVEL_MODE: "Reisemodus",
  EVENT_START_PLANNING: "Planen",
  ORDERS: "Aufträge",
  EVENT_START_SIMULATE: "Simulieren",
  FILTER_OPTIONS: "Filteroptionen",

  INVALID_ENDDATE: "Das Enddatum liegt vor dem Startdatum.",
  INVALID_ENDTIME: "Die Abfahrtszeit liegt vor der Ankunftszeit.",
  INVALID_INPUT: "Die Eingabefelder sind falsch ausgefüllt.",
  INVALID_WEBSITE: "Ungültige Website",
  INVALID_EMAIL: "Ungültige E-Mail-Adresse",
  FIELD_REQUIRED: "Feld ist erforderlich",
  FIELD_MAX_LENGTH_32: "Die Feldlänge darf 32 Zeichen nicht überschreiten!",
  FIELD_MAX_LENGTH_1024: "Die Feldlänge darf 1024 Zeichen nicht überschreiten!",
  FIELD_MAX_LENGTH_64: "Die Feldlänge darf 64 Zeichen nicht überschreiten!",
  FIELD_MAX_LENGTH_45: "Die Feldlänge darf 45 Zeichen nicht überschreiten!",
  FIELD_MAX_LENGTH_128: "Die Feldlänge darf 128 Zeichen nicht überschreiten!",
  FIELD_NO_SPECIAL_CHARS:
    "Sonderzeichen nicht zugelassen, / \"'{} [] () # $% ^ & * |",

  DELETE_EVENT_NOK:
    "Sie sind nicht der Eigentümer von Event, Sie können es nicht löschen!",
  DELETE_EVENT: "Möchten Sie das Ereignis wirklich löschen?",

  DELETE_USER: "Benutzer löschen",
  TAGS_CATEGORIES: "Kategorien",
  DELETE_FILTERS: "Filter löschen",

  // New > still to sort out
  DIRECT_BOOKING: "Direktbuchungen",
  ASPECTS: "Aspekte",
  NEW_ASPECT: "Neu aspect",
  BRAND: "Marke",
  COPY: "Kopieren",
  REQUIRED: "erforderlich",
  SORT: "Sortieren",
  ACTIVE: "Aktiv",
  INACTIVE: "Inaktiv",
  EDIT_TRANSLATIONS: "Übersetzungen bearbeiten",
  EDIT_BATCHGROUPS: "Batchgruppen bearbeiten",
  CREATE_USER: "Konto erstellen",
  START_TYPING: "Beginnen Sie mit der Eingabe in Search",
  SQUARE_PER_PERSON: "Quadratmeter pro Person (in M2)",
  ACTIVITY: "Aktivität",
  ADD_TO_CARD: "In den Warenkorb gelegt",
  VIEW_ORDER: "Bestellung anzeigen",
  UPDATE_YOUR_ACCOUNT: " Möchten Sie, dass wir Ihr Konto aktualisieren?",
  UPDATE_USER: "Benutzer aktualisieren",
  HOUSE_NUMBER: "Hausnummer",
  SELECT_TIME: "Wählen Sie eine Zeit",
  INPUT_FIELDS_EMPTY: "Die Eingabefelder sind leer.",
  NOTHING_FILLED_IN: "Nichts ausgefüllt ",
  RETURN_TO_MY_ACTIVITIES:
    'Die Bestellung wird gespeichert. Sie kehren zur Seite "Meine Aktivitäten" zurück.',
  REDIRECT_TO_APPOINTMENTS:
    "Sie werden automatisch zu Ihren Terminen weitergeleitet",
  REDIRECT_TO_PAYMENT:
    "Sie werden automatisch zur Zahlungsseite weitergeleitet. ",
  ORDER_RECEIVED: "Ihre Bestellung ist eingegangen.",
  ORDER_INFO: "Bestellinfo ",
  ORDER_OVERVIEW: "Bestellübersicht",
  ACTIVITY_PRICE: "Aktivitätspreis:",
  ORDER_ID: "Ihre Bestellnummer:",
  YOUR_ORDER: "Deine Bestellung",
  FILL_PERSONAL_DETAILS: "Geben Sie Ihre persönlichen Daten ein. ",
  CHOOSE_PRODUCTS: "Wählen Sie Ihre Produkte",
  CHOOSE_DATE: "Wählen Sie ein Datum",
  MORE_INFO: "Mehr Info",
  ARRIVAL: "Ankunft",
  ADD_ACCOMMODATION: " Unterkunft hinzufügen",
  DAILY_ACTIVITIES: "Ihre täglichen Aktivitäten",
  DEPARTURE: "Abfahrt",
  GENERAL: "Allgemeines",
  ADDRESS: "Adresse",
  POSTAL_CODE: "Postleitzahl",
  COMPANY_NAME: "Name der Firma",
  COMPANY_EMAIL: "Firmen-E-Mail",
  PREFERENCES: "Einstellungen",
  CUSTOMERS: "Kunden",
  SEARCH: "Suche",
  ADD: "Hinzufügen",
  CREATE_USERGROUP: "Neue Benutzergruppe erstellen",
  EDIT_USERGROUP: "Benutzergruppe bearbeiten",
  DELETE_USERGROUP: "Benutzergruppe löschen",
  GROUP: "Gruppe",
  USERGROUPS: "Benutzergruppen",
  USER_ROLES: "User Roles",
  USERGROUP_NAME: "Name der Benutzergruppe",
  SEARCH_FAILED_FIRST_PART: "Ihre Suche nach",
  SEARCH_FAILED_SECOND_PART: " fand keine Ergebnisse.",
  BATCHGROUPS: "Batchgruppen",
  OPTIONS: "Optionen",
  VIEW_BATCHGROUP: "Batchgruppe anzeigen",
  CREATE_BATCHGROUP: "Erstellen einer Batchgruppe ",
  DAY_MON: "Mon",
  DAY_TUE: "Tue",
  DAY_WED: "Wed",
  DAY_THU: "Thu",
  DAY_FRI: "Fri",
  DAY_SAT: "Sam",
  DAY_SUN: "Son",
  SELECTED_DATES: "Ausgewählte Daten",
  START_END_DATE_EQUAL_ERROR:
    "Das Enddatum entspricht dem Startdatum. Bitte ändern Sie das Enddatum, um fortzufahren.",
  DETAILS: "Einzelheiten",
  OWNED_BY: "Gehört",
  VISIBLE_FOR: "Sichtbar für",
  MAIN_EVENT: "Hauptveranstaltung",
  EVENT_DELETION: "Ereignis löschen",
  ADD_LANGUAGE_PLUS: "+ Neue Sprache hinzufügen",
  ADD_LANGUAGE: "Neue Sprache hinzufügen",
  LANGUAGE: "Sprache",
  DESCRIPTION: "Beschreibung",
  ARRIVAL_TEXT_MSG: "Ankunftstextnachricht",
  DEPARTURE_TEXT_MSG: "Abflug-Textnachricht",
  PREV_SCREEN: "Zum vorherigen Bildschirm wechseln",
  DONE: "Erledigt",
  ADD_CHOICE: "Auswahl hinzufügen",
  ITEMS: "Artikel",
  ADD_ITEMS: "Artikel hinzufügen",
  CLOSE_EDIT_WINDOW: "Bearbeitungsfenster schließen",
  WARNING: "Warnung",
  UNSAVED_CHANGES:
    "Sie haben noch nicht gespeicherte Änderungen! Sind Sie sicher, dass Sie die Änderungen rückgängig machen möchten?",
  EVENT_DETAILS: "Veranstaltungsdetails",
  EVENT_INFO: "Die Info",
  MESSAGE_DELETION: "Löschen von Nachrichten",
  PLAY_AUDIO: "Audio abspielen",
  DELETE_AUDIO: "Audio löschen",
  UPLOAD_EVENT_PIC: "Laden Sie ein Ereignisbild hoch",
  DELETE_LOGO: "Logo löschen",
  RESULT: "Ergebnis",
  IMAGE: "Bild",
  GO: "Gehen",
  SEARCH_OSM: "Suchen Sie in OpenStreetMap",
  STREET: "Straße",
  CITY: "Stadt",
  COUNTRY: "Land",
  TELEPHONE: "Telefon",
  OPENING_HOURS: "Öffnungszeiten (Mo - Fr 08:00 - 17:30)",
  TRANSPORTATION: "Transport",
  OK: "Ok",
  MY_APPOINTMENTS: "Meine Aktivitäten",
  INPUT_RELATION_NAME: "Geben Sie den Namen der Beziehung ein",
  MIN_GROUPSIZE: "Die Gruppengröße muss mindestens 1 betragen",
  NO_VALID_TIME_INPUT:
    "Die Zeitangabe ist ungültig. Bitte geben Sie eine gültige Zeit ein.",
  EVENT_EDITING: "Ereignis bearbeiten",
  DELETING_EVENT: "Ereignis löschen",
  NEW_EVENT: "Neues Event",
  EDITING: "Bearbeitung ",
  LOCATION: "Standort",
  EVENT_CAPACITY: "Maximale Kapazität in Personen",
  LEAD_TIME: "Vorlaufzeit",
  COOLDOWN_TIME: "Abklingzeit",
  DURATION: "Dauer",
  SELECT_SUBACTIVITIES: "Wählen Sie Unteraktivitäten aus",
  SELECTED_SUBACTIVITIES: "Ausgewählte Unteraktivitäten",
  EVENT_PICTURE: "Ereignisbild",
  CATEGORIES: "Kategorien",
  AVAILABLE_OTHER_ACCOUNTS: "Verfügbar für andere Konten",
  VISIBILITY: "Sichtweite",
  ALL_EVENTS: "Alle Veranstaltungen",
  NO_EVENT_AVAILABLE: "Keine Veranstaltungen verfügbar",
  NAME: "Name",
  UPLOAD_IMAGE: "Bild hochladen",
  USER_NOT_LOGGED_IN_TO_RETRIEVE_PAYMENTS:
    "Leider sind Sie nicht angemeldet, um Zahlungsinformationen abzurufen. Bitte einloggen und erneut versuchen!",
  GROUP_SIZE: "Gruppengröße",
  QUANTITY: "Menge",
  TOTAL: "Gesamt",
  SUBTOTAL: "Zwischensumme",
  ADD_TAGS: "Tags hinzufügen",
  TOTAL_INCIDENTS: "Gesamtzahl der Vorfälle",
  ADD_INCIDENT: "Vorfall hinzufügen",
  VIEW_DETAILS: "Details anzeigen",
  SAVE_INCIDENT: "Vorfall speichern",
  SAVE_IMAGE: "Bild speichern",
  ADD_LOCATION: "Ort hinzufügen",
  ADD_A_LOCATION: "Füge einen Ort hinzu",
  EDIT_LOCATION: "Standort bearbeiten",
  DEL_LOCATION: "Ort löschen",
  TOURCREATION_GENERATE:
    "Klicken Sie auf die Schaltfläche, um eine Route mit den oben angegebenen Parametern zu erstellen. Es ist obligatorisch, auf die Schaltfläche zu klicken, wenn die Route nicht zum ersten Mal generiert wird.",
  TOURCREATION_MANUAL_DESC:
    "Der manuelle Modus bietet eine Vielzahl von manuellen Optionen. Alle im manuellen Modus aufgelisteten Optionen sind möglich, ohne die Route neu zu generieren.",
  TOURCREATION_STOPS_DESC:
    "Nur im manuellen Modus können die Stopps zur Route hinzugefügt werden.",
  TOURCREATION_PATHPOINTS_DESC:
    "Pfadpunkte dienen beispielsweise zum Erstellen einer manuellen Route: Wenn die Route durch das Wasser führt, in dem keine Straße verfügbar ist, müssen Sie den manuellen Modus verwenden. Pfadpunkte sind wertvoll, wenn sich die Route zu einem bestimmten Punkt bewegt, der keine Straße ist. Die Pfadpunkte sind einstellbar und können in einen Stopp oder einen Punkt geändert werden. Pfadpunkte können ebenfalls entfernt werden. Wenn Sie beispielsweise Punkt 13 entfernen, wird Punkt 14 zu Punkt 13 und hängt sich an Punkt 12 an.",
  TOURCREATION_MANUAL_HOWTO:
    "Wenn Sie auf das Pluszeichen klicken, um einen Pfadpunkt hinzuzufügen, gelangen Sie in den Add-Modus. Im Add-Modus können Sie Pfadpunkte hinzufügen, indem Sie auf die Karte klicken. Wenn Sie den Add-Modus verlassen möchten, klicken Sie auf die Schaltfläche 'Hinzufügen von Pfadpunkten beenden'.",
  TOURCREATION_AUTO_DESC:
    "Der automatische Modus bietet die Möglichkeit, Wegpunkte zur Route hinzuzufügen / zu löschen.",
  TOURCREATION_WAYPOINTS_DESC:
    "Wegpunkte dienen dazu, eine Route über Straßen zu erstellen. Wenn ein Wegpunkt außerhalb der Straße platziert wird, bewegt sich die Route nicht zu diesem Punkt. Immer wenn ein Wegpunkt hinzugefügt oder gelöscht wird, wird die Route neu generiert. Dies bedeutet, dass die Pfadpunkte einschließlich der Stopps gelöscht werden. Wenn Sie eine vorhandene Route ändern möchten, öffnen Sie bitte die Registerkarte 'Handbuch'.",
  TOURCREATION_WAYPOINTS_HOWTO:
    "Durch Klicken auf die Plus-Schaltfläche zum Hinzufügen eines Wegpunkts gelangen Sie in den Add-Modus. Im Add-Modus können Sie Wegpunkte hinzufügen, indem Sie auf die Karte klicken. Wenn Sie den Add-Modus verlassen möchten, klicken Sie auf die Schaltfläche 'Hinzufügen von Wegpunkten beenden'. Immer wenn Sie auf die Schaltfläche geklickt haben, wird die Route neu generiert.",
  LINK_ACTIVATE_ACCOUNT:
    "Öffnen Sie den Link in der Mail, um Ihr Konto zu aktivieren.",
  WRONG_TIME_INPUT:
    "Die Zeitangabe ist ungültig. Bitte geben Sie eine gültige Zeit ein.",
  MESSAGE_TITLE_TEXT:
    "Bitte geben Sie den Titel und den Text der Nachricht ein, um fortzufahren",
  ERROR_MSG_NO_PLACE_SUB_EVENT:
    "There is no place available for a chosen sub event(s): ",
  ERROR_MSG_INVALID_TIME: "Ungültige Zeiteingabe",
  ERROR_MSG_INVALID_DATE: "Ungültige Datumsangabe",
  ERROR_MSG_NO_ENTRY_TRANSPORT:
    "Für diese Art des Transports sind keine Einstiegspunkte mehr verfügbar",
  ERROR_MSG_EVENTS_RESET:
    "Ihre Ereignisse wurden zurückgesetzt, bitte wählen Sie sie erneut aus.",
  ERROR_MSG_ARRIVAL_DEPARTURE:
    "Bitte ändern Sie die Ankunfts- oder Abfahrtszeit.",
  WARNING_MSG_EARLY: "Sind Sie sicher, dass Sie ankommen möchten?",
  MAIN_EVENT_START: "Das Main Event beginnt um",
  ERROR_MSG_NO_PLACE_MAIN_EVENT:
    "Für das Main Event ist kein Platz verfügbar: ",
  ERROR_MSG_NO_PLACE_TRANSPORT_MODE:
    "Für das gewählte Transportmittel sind keine Plätze mehr verfügbar",
  ERROR_MSG_NO_MAIN_BATCH_CHOSEN_TIME:
    "Keine Hauptcharge im Zeitbereich, bitte wählen Sie einen anderen Zeitbereich",
  SELECT_TRIP_DAY:
    "Bitte wählen Sie den Tag aus, an dem Ihre Reiseliste angezeigt werden soll",
  ENTER_SPECIAL_CODE: "Geben Sie einen speziellen Code ein",
  WRONG_INPUT: "Falsche Eingabe",
  INPUT_NOT_COMPLETE: "Ihre Eingabe ist nicht vollständig oder richtig",
  VALID_VIP_CODE: "Bitte geben Sie einen gültigen VIP-Code ein",
  MY_EVENTS: "Meine Veranstaltungen",
  PART_OF: "Teil von",
  SELECTION_OF_USERS: "Auswahl der Benutzer",
  CRITERIA_BOTH: "Registrierte und nicht registrierte Benutzer",
  CRITERIA_REG: "Registrierte Benutzer",
  CRITERIA_NOT_REG: "Nicht registrierte Benutzer",
  UG_FOR_USER: "Verfügbare Benutzergruppen",
  SELECTED_UG_FOR_USER: "Benutzer ist bereits registriert für:",
  WEB_BROWSER_VERSION: "Chrome-Browserversion",
  UPDATE_BROWSER_DETECTION:
    "Das System hat festgestellt, dass die Version des Chrome-Browsers, an dem Sie arbeiten, nicht aktuell ist.",
  UPDATE_BROWSER_FAILS:
    "Aus diesem Grund konnten einige Funktionen nicht ordnungsgemäß funktionieren.",
  UPDATE_BROWSER:
    "Bitte aktualisieren Sie Ihren Chrome-Browser auf die neueste Version.",
  CALENDAR: "Was läuft",
  ONLY: "Nur",
  FREE_PLACES: "Plätze verfügbar",
  MINUTES: "Protokoll",
  BOOK: "Buch",
  LOCATION_PICTURE: "Standortbild",
  UPLOAD_LOCATION_PIC: "Laden Sie ein Standortbild hoch",
  TOGGLE_MAP: "Karte umschalten",
  TOGGLE_ACTIVITYLIST: "Tägliche Aktivitäten anzeigen",

  // Partner
  PARTNER_LEVEL: "Partnerebene",
  PARTNERS: "Partner",
  PARTNER_DETAILS: "Partnerdetails",
  DELETE_PARTNER_TITLE: "Sind Sie sicher, den Partner zu löschen?",
  PARTNER_NAME: "Partnername",
  PARTNER_ADDRESS: "Partneradresse",
  PARTNER_CITY: "Partnerstadt",
  PARTNER_EMAIL: "Partner-E-Mail",
  ADMINISTRATION_PARTNER_EMAIL: "Partner administration email",
  PARTNER_POSTAL_CODE: "Postleitzahl des Partners",
  PARTNER_IBAN: "Partner IBAN",
  PARTNER_TYPE: "Partnertyp",
  SERVICE_PRICE: "Servicepreis",
  SERVICE_PRICE_PERCENTAGE: "Servicepreisprozentsatz",
  SERVICE_MINIMUM_PRICE: "Minimaler Servicepreis",
  PLANNING_CONTRACT: "Planungsvertrag",
  PAYMENT_CONTRACT: "Zahlungsvertrag",
  PAYMENT_PLATFORM: "Zahlungsplattform",
  CREATE_PARTNER: "Partner erstellen",
  TERMS_ACCEPT: "Ich akzeptiere das",
  DIRECT_DEBIT: "Ich akzeptiere Lastschrift",
  ACTIVE_PARTNER: "Partner aktivieren",
  MIN_MONTHLY_FEE: "Minimale monatliche Gebühr",
  SERVICE_ORDER_VALUE_THRESHOLD: "Schwellwert für Serviceauftragswert",

  //Event Delivery fees
  EVENT_DELIVERY_FEE: "Lieferkosten",
  EVENT_DELIVERY_FEE_BUTTON:
    "Klicken Sie auf die Schaltfläche unten, um die Zustellgebühren für die Veranstaltung zu öffnen",
  DELIVERY_FEES_CONFIGURATOR: "Konfigurator für Versandkosten",
  STANDARD_DELIVERY_FEE: "Standardversandgebühr",
  EXPL_STANDARD_DEL_FEE:
    "Dies ist die Fallback-Option, wenn die Postleitzahl des Benutzers nicht mit den Postleitzahlen der zusätzlichen Zustellgebühr übereinstimmt." +
    "Die Standardversandgebühr ist obligatorisch, wenn Sie zusätzliche Zustellgebühren für bestimmte Postleitzahlen hinzufügen möchten.",
  DELIVERY_FEE_WHOLECOUNTRY:
    "Wählen Sie diese Option, wenn die Zustellgebühr nicht für bestimmte Postleitzahlen gilt, sondern für das gesamte Land.",
  ADDITIONAL_DELIVERY_FEE: "zusätzliche Zustellgebühr",
  EXPL_ADDITIONAL_DEL_FEE:
    "Zusätzliche Zustelloptionen für eine Reihe von Postleitzahlen können hier hinzugefügt werden.",
  NEW_DELIVERY_FEE: "Neue Zustellgebühr",
  POSTAL_CODES: "Postleitzahlen",
  POSTAL_CODE_RANGE: "neuer Postleitzahlenbereich",
  NEW_DELIVERY_FEE: "neue Zustellgebühr",
  EDIT_DELIVERY_FEE: "Zustellgebühr bearbeiten",
  NEW_POSTAL_CODE_RANGE: "Neuer Postleitzahlbereich",
  EDIT_POSTAL_CODE_RANGE: "Postleitzahlenbereich bearbeiten",
  ONLY_NUMBERS_ALLOWED: "Es sind nur Zahlen erlaubt",
  MIN_ORDER_VALUE: "Mindestbestellwert",
  DELIVERY_ALLOWED: "Lieferung erlaubt",

  // Empty slots
  EMPTY_SLOTS_TITLE: "Sind Sie sicher, diese Steckplätze zu leeren?",

  //Suggestions
  SUGGESTIONS_SELECTED: "Ausgewählte Vorschläge",
  SUGGESTIONS_SELECT: "Vorschläge auswählen",
  SUGGESTIONS: "Vorschläge",
  SUGGESTIONS_NO_PLACES:
    "Die Vorschläge haben keine Plätze mehr. Sie können einen anderen Vorschlag wählen.",
  SUGGESTION_BOOK_FAILED: "Buchvorschlag nicht möglich",
  NO_SUGGESTIONS_FOUND: "Keine Vorschläge gefunden",
  NO_SUGGESTIONS: "Es wurden keine Vorschläge gefunden",
  NO_CAPACITY: "Keine Kapazität",
  LIST_OF_SUGGESTIONS: "Liste der Vorschläge",
  ADD_SUGGESTION: "Vorschlag hinzufügen",
  ADD_SUGGESTION_ACCEPT:
    "Möchten Sie diesen Vorschlag wirklich zu Ihrer Bestellung hinzufügen?",
  CANCEL_YOUR_ORDER: "Bestellung stornieren",
  CANCEL_YOUR_ORDER_ACCEPT: "Möchten Sie Ihre Bestellung wirklich stornieren?",
  REMOVE_SUGGESTION: "Vorschlag entfernen",
  REMOVE_SUGGESTION_ACCEPT: "Möchten Sie diesen Vorschlag wirklich entfernen?",
  NO_IM_NOT: "Nein, bin ich nicht",
  YES_I_AM: "Ja, ich bin",
  SUGGESTION_MAKE_CHOICE: "Entscheide dich",
  SUGGESTION_DRINKING: "ich möchte etwas zu trinken",
  SUGGESTION_EATING: "ich will etwas zu essen haben",

  //Calendar
  CALENDAR_EVENT_STARTTIME: "Startzeit",
  CALENDAR_EVENT_ENDTIME: "Endzeit",
  CALANDER_NAME: "Kalender",
  CALENDAR_NO_ITEMS:
    "Für die ausgewählten Tage gibt es keine Kalenderelemente.",

  //Statistics
  GET_STATISTICS: "Statistiken abrufen",
  STATISTICS_OF_TRIPS: "Statistik der Reisen",
  STATISTICS_OF_SUGGESTIONS: "Statistik der Vorschläge",
  STATISTICS_OF_DIRECT_BOOKING: "Statistik der Direktbuchungen",
  STATISTICS_OF_PARTNERS: "Statistik der Partner",
  STATISTICS_OF_USERS: "Statistik der Benutzer",
  STATISTICS_SELECT_THE_DATES: "Wählen Sie die Daten aus",
  STATISTICS_SELECT_THE_PARTNER: "Wählen Sie den Partner aus",

  // Activity details screen
  BACK_TO_PARENT: "zurück zum vorherigen Ereignis",
  CHOOSE_A_LOCATION: "Wählen Sie einen Ort",
  CHOICES: "Entscheidungen",
  READ_MORE: "Weiterlesen",
  READ_LESS: "Lese weniger",
  DELIVERY_FEE: "Zustellgebühr",
  MORE_PRODUCTS: "mehr Produkte",
  OR_ORDER_FOR: "Oder bestellen für",
  SELECT_THIS: "Wenn Sie diese auswählen, müssen Sie bezahlen",
  CONFIRM_YOUR_CHOICES: "Bestätigen Sie Ihre Auswahl",
  CONFIRM_YOUR_CHOICES_EXPLANATION:
    "Überprüfen Sie Ihre Auswahl und drücken Sie Bestätigen.",
  PERSONAL_DETAILS_EXPLANATION:
    "Geben Sie die erforderlichen persönlichen Daten ein und hinterlassen Sie auf Wunsch einen Kommentar für Sonderwünsche.",
  ENTER_YOUR_PERSONAL_DETAILS: "Geben Sie ihre Persönliche Daten ein",
  CHOOSE_AN_OPTION: "Wähle eine Option",
  CLICK_TO_OPEN: "Klicken Sie zum Öffnen",
  STARTING_AT: "von",
  AND: "Und",
  SHOWING_OPTION:
    "Geben Sie die Anzahl der Personen der gewünschten Option oder des gewünschten Tickets an.",
  SELECTED_DATA_EXPLANATION:
    "Wählen Sie ein Datum oder einen Zeitraum sowie eine Start- und Endzeit sofern anwendbar.",
  PRODUCT_BELOW_EXPLANATION:
    "Nachfolgend finden Sie die Produkte. Fügen Sie die gewünschten Produkte hinzu und klicken Sie dann auf Jetzt bestellen.",
  BOOKING_FLOW_EXPLANATION:
    "Sie befinden sich jetzt im Buchungsprozess und füllen die folgenden Felder aus, um fortzufahren.",
  EXPLAINING_COLOR_CHIPS:
    "Die folgenden Farben geben an, wie beschäftigt es in bestimmten Zeitfenstern ist",
  NO_PRODUCTS: "In Ihrem Warenkorb befinden sich keine Produkte",
  NO_DAYS_AVAILABLE: "Keine Tage verfügbar",
  NO_BOOKINGS_YET: "Es wurde noch nichts gebucht",
  PRE_EVENT_NOTIFICATIONS: "Aktivieren Sie Benachrichtigungen vor dem Ereignis",
  PRE_EVENT_NOTIFICATIONS_EXPLANATION:
    "Wenn Sie dies auswählen, erhalten Sie einige Minuten vor Beginn des Ereignisses eine Nachricht.",
  NO_ENDTIMES:
    "Endzeiten mit der gewählten Startzeit können nicht ermittelt werden. Bitte wählen Sie eine andere Startzeit.",
  CANT_FIND_STARTIME:
    "Mit diesem Startdatum kann keine Startzeit gefunden werden",
  CANT_FIND_ENDDATE: "Mit dieser Startzeit kann kein Enddatum gefunden werden",
  CANT_FIND_ENDTIME: "Mit diesem Enddatum kann keine Endzeit gefunden werden",
  CHOSEN_DETAILS: "Ausgewählte Details",
  STARTDATE: "Anfangsdatum",
  ENDDATE: "Endtermin",
  ACCEPT: "Akzeptieren",
  AMOUNT: "Menge",
  AVA_DAYS: "Verfügbare Tage",
  OPEN_HOURS: "Öffnungszeiten",
  HOURS: "Stunde",
  PRICE: "Preise ab",
  PRICE2: "Preis",
  CONTACT: "Kontakt",
  PHONE_NR: "Telefonnummer",
  PHONE_NR_REQUIRED: "Telefonnummer (erforderlich)",
  REQUEST_CLIENT1: "Wähle eine Zeit",
  REQUEST_CLIENT2: "Bitte wählen Sie eine Anzahl von Tickets.",
  OPENED_AT: "Geöffnet um",
  CLOSED_AT: "Geschlossen um",
  SAVE_DETAILS:
    "Speichern Sie die persönlichen Daten in meinem Konto für zukünftige Reservierungen oder Bestellungen",
  NO_PLACE: "Kein Platz",
  NO_PLACE_BATCH:
    "Kein Platz in diesem Zeitfenster, bitte wählen Sie einen anderen",
  FREE_DELIVERY: "Kostenlose Lieferung",
  EX_DELIVERY_FEE: "Ex. Liefergebühr",
  MONDAY: "Montag",
  TUESDAY: "Dienstag",
  WEDNESDAY: "Mittwoch",
  THURSDAY: "Donnerstag",
  FRIDAY: "Freitag",
  SATURDAY: "Samstag",
  SUNDAY: "Sonntag",
  PRICE_PERCENTAGE: "Preisprozentsatz",
  PRICE_OVERVIEW: "Preisübersicht",
  PERCENTAGE_EXPLANATION:
    "Dieser Prozentsatz zeigt den Prozentsatz des ursprünglichen Preises an.",
  UNAVAILABLE: "Nicht verfügbare Artikel",
  UNAVAILABLE_TEXT:
    "Es sind keine Artikel verfügbar. Akzeptieren Sie, dass Sie diese Artikel nicht kaufen können?",
  PLEASE_STARTDATE: "Bitte wählen Sie ein Startdatum",
  PLEASE_ENDDATE: "Bitte wählen Sie ein Enddatum",
  PLEASE_STARTTIME: "Bitte wählen Sie eine Startzeit",
  PLEASE_ENDTIME: "Bitte wählen Sie eine Endzeit",
  CROWDED: "Überfüllt",
  UNCROWDED: "Nicht überfüllt",
  NORMAL: "Normal",
  BOOKED: "Gebucht",
  OUT_OF_STOCK: "Dieses Produkt ist nicht auf Lager",
  AVAILABLE_PRICES: "Verfügbare Preise",
  PRODUCT_INFO: "Produktinformation",
  PRICE_STARTING_AT: "Preis ab",
  NOT_AVAILABLE: "Nicht verfügbar",
  ALMOST_FULL: "Fast voll",
  NOT_BUSY: "Nicht beschäftigt",
  SELECT_ORDERTYPE: "Bitte wählen Sie die Art der Bestellung",
  REMARK: "Bemerkungen",
  REMARK_OPTIONAL: "Bemerkungen (optional)",
  DELIVERY_DISTANCE: "Lieferentfernung",

  REGISTER_PAGE_TEXT:
    "Um Ihren persönlichen AccountName-Pass zu erstellen, benötigen wir nur Ihre E-Mail-Adresse. Ihre E-Mail-Adresse wird auch verwendet, um Ihnen Buchungsbestätigungen und Tickets zu senden, wenn Sie Aktivitäten buchen.",
  REGISTER_PAGE_WELCOME:
    "Zum Erstellen Ihres Kontos benötigen wir nur Ihre E-Mail-Adresse. Ihre E-Mail-Adresse wird auch verwendet, um Ihnen Buchungsbestätigungen und Tickets zu senden, wenn Sie Aktivitäten buchen.",
  LOGIN_PERSONAL:
    "Bitte melden Sie sich bei Ihrem persönlichen AccountName-Pass an. Sie haben noch keinen Reisepass? Registrieren Sie sich, um eine in nur einer Minute zu erstellen. Mit Ihrem AccountName-Pass können Sie Ihren Besuch bei accountName ganz einfach planen und buchen, Ihre Lieblingsaktivitäten speichern und Rabatte für Ihren Besuch bei accountName erhalten.",

  //orders
  ORDER: "Wählen ereignis",
  ORDER_LIST_EMPTY: "Liste ist leer",
  ORDER_NO_ORDERS: "keine Bestellungen",
  ORDER_NO_ORDERS_FOUND: "Es wurden keine Bestellungen gefunden",
  ORDER_DOWNLOAD: "herunterladen",
  ORDER_NOW: "Jetzt bestellen",
  ORDER_TYPE: "Auftragsart",
  ORDER_NR: "Bestellnummer",
  ORDER_DETAILS: "Bestelldetails",
  ORDER_STATUS: "Order status",

  // Error codes
  E_00_00:
    "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut",
  E_PO_010:
    "Die verschiedenen Slots für die Aktivität waren momentan nicht verfügbar. Bitte versuchen Sie es später erneut",
  E_PO_011:
    "Es war nicht möglich, der Planboard eine Aktivität hinzuzufügen. Überprüfen Sie Ihre Planboard und versuchen Sie es mit einem anderen Datum oder einer anderen Uhrzeit.",
  E_PO_012:
    "Es war nicht möglich, der Planboard eine Aktivität hinzuzufügen. Bitte versuchen Sie es später erneut",
  E_PO_013:
    "Der ausgewählte Steckplatz hat keine Kapazität. Bitte versuchen Sie es mit einem anderen Steckplatz, falls verfügbar.",
  E_PO_014:
    "Es war nicht möglich, die ausgewählte Aktivität in Ihrem Planboard zu ändern",
  E_PO_015:
    "Sie dürfen diese Aktivität nicht bearbeiten, da der Zahlungsstatus nicht 'bezahlt' ist.",
  E_PO_016:
    "Die gewählte Zeit ist in einer anderen Slots-Gruppe, bitte wählen Sie eine andere Zeit",
  E_BK_001:
    "Leider ist der gewählte Veranstaltungsort zu voll. Bitte versuchen Sie, die Ankunfts- oder Abfahrtszeit zu ändern und versuchen Sie es erneut.",
  E_BK_002:
    "Keines der von Ihnen ausgewählten Produkte ist verfügbar. Bitte wählen Sie eine andere Zeit oder ein anderes Produkt und fahren Sie fort.",
  E_PC_003:
    "Sie können keine Preiskategorie löschen, die bereits mit einem Zeitfenster verknüpft ist",
  E_PB_001: "Keine Ankunftskapazität verfügbar",
  E_PB_002: "Keine Abflugkapazität verfügbar",
  E_PB_003: "Keine Veranstaltungskapazität verfügbar",
  E_OB_002:
    "Das ausgewählte Ereignis konnte seine Daten nicht abrufen. Bitte versuchen Sie es später erneut",
  E_UG_002: "Die Bestellung gehört nicht dem aktuellen Partner",
  E_UG_003: "Die Bestellung wurde bereits gescannt",
  E_UG_004: "Die Tickets innerhalb der Bestellung werden nicht bestätigt",

  E_ROUTE_001: "keine Kapazität",
  E_ROUTE_002:
    "Es gab keine Bestellungen in der Datenbank für die angegebene Eingabe",
  E_ROUTE_003:
    "Der Routengenerator hat innerhalb der angegebenen Zeit keine Lösung gefunden",
  E_ROUTE_004: "Es gibt keine Lösung für das angegebene Routing-Problem",
  E_ROUTE_005: "Routengenerator nicht richtig konfiguriert",
  E_ROUTE_006:
    "Keine Route gefunden, bitte versuchen Sie es mit einem anderen Reisemodus",

  E_MPID_001: "Die Zahlungs-ID fehlt",

  E_GSD_001: "Es gibt keine Startdaten",
  E_GSD_002: "Es gibt keine Enddaten",
  E_GSD_003: "Es gibt keine Startzeiten",
  E_GSD_004: "Es gibt keine Enddaten",
  E_RA_001:
    "Das Abrufen der Ereignisdaten ist fehlgeschlagen. Bitte versuchen Sie es später erneut",
  E_RA_002:
    "Das Abrufen der Routenaspektdaten ist fehlgeschlagen. Versuchen Sie es später erneut",
  E_RA_003:
    "Die empfangenen Routenaspektdaten sind nicht für das richtige Ereignis. Bitte versuchen Sie es später erneut",
  E_RA_004:
    "Das Abrufen der Pfadpunkte innerhalb der Routenaspektdaten ist fehlgeschlagen. Versuchen Sie es später erneut",

  E_OM_001: "Die Bestellnummer ist falsch.",
  E_OM_002: "Die Bestätigungs-ID gehört nicht zur Bestell-ID.",
  E_OM_003: "Die Bestellung wurde bereits angenommen / abgelehnt.",

  // Back-End Failure
  W_BEF_001:
    "Die empfangenen Daten sind unvollständig, versuchen Sie es später erneut. ",
  W_BEF_002:
    "Der Server ist derzeit offline, SuperLinda und ihr Team arbeiten sehr hart daran, ihn zu lösen. ",

  // GetAccountInfo
  W_GAI_001:
    "Die Kontodaten sind unvollständig, bitte versuchen Sie es erneut. ",

  // GetUserData
  W_GUD_001:
    "Die Benutzerdaten sind unvollständig, bitte versuchen Sie es erneut. ",
  W_GUD_002:
    "Wir konnten die Benutzerdaten nicht empfangen. Bitte versuchen Sie es erneut. ",

  // GetEventDetails
  W_GED_001:
    "Das Laden des Bildes ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",
  W_GED_002:
    "Das Laden der Beschreibung ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",
  W_GED_003:
    "Das Laden der Ereignis-ID ist fehlgeschlagen. Versuchen Sie es erneut. ",
  W_GED_004:
    "Das Laden der Ereignisdetails ist fehlgeschlagen. Versuchen Sie es erneut. ",

  // GetCalendar
  W_GC_001:
    "Das Laden des Kalenders ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GetTourActivities
  W_GTA_001:
    "Das Abrufen der Touraktivitäten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GetThemes
  W_GT_001:
    "Das Laden der Themen für das aktuelle Konto ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GetChildrenEvents
  W_GCE_001:
    "Das Laden der Ereignisse aus dem ausgewählten Thema ist fehlgeschlagen. Versuchen Sie es erneut. ",

  // GetFavourites
  W_GF_001:
    "Das Laden Ihrer Favoriten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // Add/Delete Favourite
  W_ADF_001:
    "Das Hinzufügen / Löschen eines neuen Favoriten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GetEventsForLocation
  W_GEFL_001:
    "Das Abrufen der Ereignisse für den Speicherort ist fehlgeschlagen. Versuchen Sie es erneut. ",

  // GetLocationDetails
  W_GLD_001:
    "Das Abrufen der Standortdetails ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GetEventsBasedOnUserLevel
  W_GEBOU_001:
    "Das Laden der Ereignisse ist fehlgeschlagen. Versuchen Sie es erneut. ",

  // GetLocations
  W_GL_001:
    "Das Laden der Speicherorte ist fehlgeschlagen. Versuchen Sie es erneut. ",

  // DeleteEvent
  W_DE_001:
    "Beim Löschen des Ereignisses ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. ",

  // GetPostOfEvent
  W_GPOE_001:
    "Das Laden des Event-Posters ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GetAccounts
  W_GA_001:
    "Das Laden der Konten ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // SaveEvent
  W_SE_001:
    "Das Speichern des Ereignisses ist fehlgeschlagen. Bitte versuchen Sie es später erneut. ",

  // ActivateAccount
  W_AA_001:
    "Nach der Aktivierung des Kontos wurden keine Token empfangen. Bitte versuchen Sie es erneut.. ",
  W_AA_002:
    "Die Aktivierung des Kontos ist fehlgeschlagen. Bitte versuchen Sie es erneut.",

  // CreateAccount
  W_CA_001:
    "Die E-Mail konnte nicht bestätigt werden, da keine E-Mail empfangen wurde. Bitte versuchen Sie es erneut. ",
  W_CA_002:
    "Die Erstellung des Kontos ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // UpdateAccount
  W_UA_001:
    "Das Aktualisieren des Kontos ist fehlgeschlagen. Bitte versuchen Sie es später erneut. ",

  // GetExactCsvs
  W_GEC_001:
    "Das Laden der Exact-Dateien ist fehlgeschlagen. Bitte versuchen Sie es später erneut. ",

  // GenerateSalesFees
  W_GSF_001:
    "Die Generierung der Verkaufsgebühren ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GenerateMonthlyFees
  W_GMF_001:
    "Die Generierung der monatlichen Gebühren ist fehlgeschlagen. Bitte versuchen Sie es erneut. ",

  // GetSalesFeesPref
  W_GSFP_001:
    "Es wurde kein Startdatum erhalten. Bitte versuchen Sie es erneut. ",
  W_GSFP_002:
    "Es wurde kein Enddatum erhalten. Bitte versuchen Sie es erneut. ",
  W_GSFP_003:
    "Es wurde kein Generierungsdatum empfangen. Bitte versuchen Sie es erneut. ",
  W_GSFP_004:
    "Das Laden der Einstellungen für Verkauf und Gebühren ist fehlgeschlagen. Versuchen Sie es erneut. ",

  // SetSalesFeesPref
  W_SSFP_001:
    "Das Speichern der Einstellungen für Verkauf und Gebühren ist fehlgeschlagen. Versuchen Sie es erneut. ",

  // Standard Contact Helpdesk
  W_HELPDESK_001:
    "Wenn dieses Problem weiterhin auftritt, wenden Sie sich bitte an den Helpdesk von SuperLinda. ",

  //Book
  NOT_CHOSEN: "Sie haben noch nichts ausgewählt",

  //shopping cart
  SHOPPINGCART: "Einkaufswagen",
  SHOPPINGCART_EMPTY: "Dein Einkaufswagen ist leer",

  //DeliveryRouteGenerate screen
  "TIME/DATEINFO": "Uhrzeit/Datum info",
  DELIVERY: "Lieferung",
  TRANSPORT: "Transport",
  GENERATE_ROUTE: "Route generieren",
  ADD_DELIVERY_PERSON: "Zusteller hinzufügen",
  DELIVERY_CONFIG: "Konfigurator liefern",
  DELIVERER: "Zusteller",
  ORDERID: "Auftragsnummer",
  DELIVERYNR: "Lieferungsnummer",
  NOTHING_DROPPED: "Nichts fiel herunter",
  DROPPED: "Fallen gelassen",
  LOCATION_NOT_FOUND: "Ort nicht gefunden",
  CAR: "Auto",
  BICYCLE: "Fahrrad",
  WALKING: "Gehen",
  HOUR: "Stunde",
  START_CONFIGURE: "Starten Sie zuerst die Konfiguration",

  //Lorenzo added new translations not in Deutsch
  UNCONFIRMED: "Unbestätigt",
  CONFIRMED: "Bestätigt",
  WAITING_FOR_PAYMENT: "Warten auf Zahlung",
  ARRIVED: "Ist eingetroffen",
  FIRSTNAME: "Vorname",
  LASTNAME: "Nachname",
  PLACE_OF_RESIDENCE: "Wohnort",
  DATE_OF_BIRTH: "Geburtsdatum",

  USER_SUCCESS_ACTIVATED: "Die Aktivierung Ihres Kontos ist abgeschlossen!",
  USER_SUCCESS_ACTIVATED_LINK:
    "Wenn Sie Ihr Konto bei der App registriert haben, öffnen Sie die App, um fortzufahren.",
  USER_SUCCESS_ACTIVATED_DOWN:
    "Sind Sie ein Webbenutzer? Wir haben auch eine App zur Verfügung. Klicken Sie auf den richtigen Store, um die App herunterzuladen oder im Internet fortzufahren",
  USER_NOT_ACTIVATED_TEXT:
    "Ihr Konto wurde noch nicht aktiviert. Klicken Sie in der Aktivierungsmail, die Sie erhalten haben, auf den Aktivierungslink, um fortzufahren.",
  USER_NOT_ACTIVATED_MAIL:
    "Wenn Sie die E-Mail nicht finden können oder die E-Mail noch nicht erhalten haben, klicken Sie auf die Schaltfläche unten, um die Aktivierungs-E-Mail erneut zu senden an: ",
  RESEND_ACTIVATION: "Aktivierungs-Mail senden",
  ACTIVATION_MAIL_IS_SEND: "Die Mail wurde gesendet an: ",
  USER_FORGOT_PASSWORD:
    "Bitte klicken Sie auf die Schaltfläche unten, um Ihre Anmeldedaten erneut an Ihre E-Mail zu senden",
  RESEND_LOGIN_DETAILS: "Anmeldedaten senden",
  FORGOT_PASS: "Passwort vergessen? ",
  USER_PASS:
    "Verwenden Sie das folgende Passwort, um sich in der App anzumelden: ",

  EVENT_DESCRIPTION_EC: "Eventbeschreibung",
  EVENT_DURATION_EC: "Durchschnittliche Dauer",
  EVENT_PART_OF_THEMES_EC: "Teil der Themen: ",
  EVENT_BUDGET_EC: "Veranstaltungsbudget",
  EVENT_REM_BUDGET_EC: "Verbleibendes Veranstaltungsbudget",
  EVENT_PRE_EVENT_Q_EC: "Frage vor dem Event (Antwort ist immer Ja / Nein)",
  EVENT_PRE_EVENT_Q_SMALL_EC: "Frage vor dem Event",
  EVENT_MANAGED_EC:
    "Bitte wählen Sie diese Option, wenn das Ereignis von einer Planboard verwaltet wird",
  EVENT_TICKET_TYPES_EC:
    "Um Tickets zur Veranstaltung hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten",
  EVENT_BOOKING_POL_EC:
    "Um Buchungsrichtlinien für die Veranstaltung hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten",
  EVENT_SUG_EC:
    "Um der Veranstaltung Vorschläge hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten",
  EVENT_ALTER_EC:
    "Um Alternativen zur Veranstaltung hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten",
  EVENT_SUB_ACT_EC:
    "Um der Veranstaltung Unteraktivitäten hinzuzufügen, klicken Sie bitte auf die Schaltfläche unten",

  //Partner confirmation
  PAR_CON_LEAD_P1: "Die Bestätigung der Bestellung: ",
  PAR_CON_LEAD_P2: " wurde erhalten. Der neue bestätigte Status ist: ",
  PAR_CON_LEAD_P3:
    "Es wurde keine Bestätigung erhalten. Klicken Sie erneut auf den Link in Ihrer E-Mail, um es erneut zu versuchen. ",
  PAR_CON_OR_ST_ACC: "Akzeptiert",
  PAR_CON_OR_ST_REJ: "Abgelehnt",
  PAR_CON_OR_ST_FAI: "Gescheitert",
  PAR_CON_ORDER: "Order-ID: ",
  PAR_CON_CONFIRMATION: "Confirmation-ID: ",
  PAR_CON_STATUS: "Status: ",

  // Stock details
  CHANGE_STOCK: "Lagerbestand ändern",
  VALID_CAPACITY: "Bitte geben Sie eine gültige Kapazität ein",
  STOCK_PRO_SUC_CHANGED:
    "Der Bestand für das ausgewählte Produkt wurde erfolgreich geändert",
  STOCK_ITEM_SUC_CHANGED:
    "Der Bestand für den ausgewählten Produktartikel wurde erfolgreich geändert",
  CONFIRM_PRODUCT_PART_1: "Sind Sie sicher, dass Sie das Product ",
  CONFIRM_PRODUCT_PART_2: " auf 'Nicht vorrätig' setzen möchten? ",
  ENTER_NEW_PRO_STOCK:
    "Bitte geben Sie den neuen Bestand für das Produkt ein: ",
  CONFIRM_ITEM:
    "Bitte bestätigen Sie, dass Sie das ausgewählte Produkt auf 'Nicht vorrätig' setzen möchten. ",
  ENTER_NEW_ITEM_STOCK:
    "Bitte geben Sie den neuen Bestand unten für den Produktartikel ein.",

  //location
  LOCATION_SQUARE_PER_PERSON: "Geben Sie den Mindestmeter pro Person ein",
  LOCATION_PUBLIC_TRANSPORT: "öffentlicher Verkehr",
  LOCATION_MARK_LOCATION: "Position markieren",
  LOCATION_BOUNDARIES: "Grenzen",
  LOCATION_LATITUDE: "Latitude",
  LOCATION_LONGITUDE: "Longitude",
  LOCATION_RADIUS: "Strahl",
  LOCATION_USED_BY: "Benutzt von",
  LOCATION_ENTRY_POINT: "Einstiegspunkt",
  LOCATION_ENTRY: "Eingang",
  LOCATION_EXIT: "Ausgang",
  "LOCATION_ENTRY/EXIT": "Eingang / ausgang",
  LOCATIONS_CONTAINS: "Ort enthält",
  LOCATION_ARE_YOU_SURE: "Kinder! bist du sicher?",

  //map
  MAP_SELECT_LOCATION: "Wählen Sie einen Ort mit: Rechts + Klicken.",
  MAP_TOUR_CONFIGURATION: "Konfiguration für die Tour",
  MAP_SELECTED_TOUR_ACTIVITIES: "Ausgewählte Touraktivitäten",

  //Policies
  POLICIES_EXPLANATION: "Einige Erklärungen zu Ereignisrichtlinien",
  POLICIES_NEW: "Neue Richtlinien",

  //Filter
  FILTER_SELECT: "Filter auswählen",
  FILTER_NO_SELECTED: "Keine Filter ausgewählt",
  FILTER_SELECTED: "Ausgewählte Filter",

  //Alternative
  ALTERNATIVE_SELECT: "Wählen Sie Alternativen aus",
  // Reviews
  REVIEWS_LOAD_MORE: "Mehr laden",
  REVIEWS: "Bewertungen",
  REVIEW: "Bewertung",
  REVIEW_WRITE: "eine Rezension schreiben",

  // Calendar quadrants
  CQ_ORDERDETAILS: "Bestelldetails",
  CQ_EXT_EVE_INFO: "Außenbuchung, nicht alle Details können angezeigt werden.",
  CQ_USER_DETAILS: "Nutzerdetails",
  CQ_WEEK_VIEW: "Wochenansicht",
  CQ_MONTH_VIEW: "Monatsansicht",
  CQ_DATE_STRING_TYPE: "de-de",

  // Account category
  CATEGORY_NAME: "Name of the category",
  CATEGORY_RANKING: "Ranking of the category",
  DELETE_CATEGORY: "Are you sure you want to delete the selected category",

  // Map icons
  MAP_ICONS: "Map Icons",
  ICON_NAME: "Icon name",
  GREEN_ICON: "Green icon",
  YELLOW_ICON: "Yellow icon",
  RED_ICON: "Red icon",
  EDIT_MAP_ICON: "Edit map icon",
  ADD_MAP_ICON: "Add map icon",
  DELETE_MAP_ICON: "Are you sure to delete the selected map icon",

  // Webshop event
  EVENT_PICKUP_DELIVERY_EC:
    "To add pickup/delivery events, please click on the button below",
  PICKUP_DELIVERY_EVENTS: "Pickup/Delivery Events",
  SELECT_PICKUP_DELIVERY_EVENTS: "Select pickup/delivery events",
  SELECTED_PICKUP_DELIVERY_EVENTS: "Selected pickup/delivery events",

  // Weighted product info
  WEIGHTED_INFO_HEADER: "Weighted product information",
  UNIT_HEADER: "Unit",
  STEP_SIZE_HEADER: "Step size",
  PRICE_PER_STEP_HEADER: "Price per step",
  MINIMUM_QUANTITY_HEADER: "Minimum quantity",
  OVERVIEW_SIZE_HEADER: "Overview size",
  FIXED_PRICE_HEADER: "Fixed price",
  UNIT_INFO: "Unit of the product, like gram",
  STEP_SIZE_INFO: "Step size",
  PRICE_PER_STEP_INFO: "Price per step",
  MINIMUM_QUANTITY_INFO: "Minimum quantity",
  OVERVIEW_SIZE_INFO: "Overview size",
  FIXED_PRICE_INFO: "Fixed price",

  // Product discount
  PRODUCT_ITEMS_WITHOUT_DISCOUNT: "Product items without discounts",
  PRODUCT_ITEMS_WITH_DISCOUNT: "Product items with discounts",
  STOP_DISCOUNT: "Stop Discount",
  START_DISCOUNT: "Start Discount",
  ORIGINAL_PRICE: "Original price",
  DISCOUNT_PRICE: "Discount price",

  PRODUCT_CATEGORY_PICTURE: "Picture",

  // Partner groups
  PARTNER_GROUPS: "Partner groups",
  DELETE_PARTNER_GROUP: "Partnergruppe löschen",
  PARTNER_GROUP_NAME: "Name der Partnergruppe",
  PARTNER_GROUP_PARTNERS: "Partnergruppe Partner",
  ADJUST_PARTNERS_FROM_PARTNERGROUP:
    "Passen Sie Partner aus der Partnergruppe an",
  USING_COMMON_APP: "Gemeinsame App verwenden",
  DUPLICATED_PARTNER_GROUP_NAME_ERROR:
    "Entschuldigung, der Name der Partnergruppe existiert bereits. Bitte ändern Sie den Namen und versuchen Sie es erneut.",
  SELECT_PRIMARY_AND_SECONDARY_COLOR:
    "Bitte wählen Sie eine Primär- und eine Sekundärfarbe",
  ANDROID_STORE_URL: "Android-Store-URL",
  APPLE_STORE_URL: "Apple Store-URL",
  PARTNER_LEVEL: "Partnerniveau",

  // User states
  USER_UNKNOWN: "Unbekannt",
  USER_STATE_1: "Registriert, nicht aktiviert",
  USER_STATE_2: "Registriert und aktiviert",
  USER_STATE_3: "Gelöscht",
  USER_STATE_4: "Buchung ohne Anmeldung",
  USER_STATE_5: "Importiert",
  USER_STATE_6: "Interessiert",

  DELETE_PARTNER_FEE_CONFIRM_TITLE:
    "Möchten Sie diese Gebühr für den Partner wirklich löschen?",

  PARTNER_DISPLAY_NAME: "Anzeigename"
};
